"use strict";

var vgsettings = {
  protocol: 'https'
  , vimeoprotocol: 'https:'
};

/*
 * Author: Digital Zoom Studio
 * Website: http://digitalzoomstudio.net/
 * Portfolio: http://codecanyon.net/user/ZoomIt/portfolio?ref=ZoomIt
 * This is not free software.
 * Video Gallery
 * Version: 10.76
 */

var youtubeid_array = []; // -- an array to hold inited youtube videos
var dzsvp_players_arr = []; // -- an array to hold video players
var dzsvp_yt_iframe_settoload = false;

require('./js_dzsvg/_dzsvg_window_vars');
var helpersSvg = require('./js_dzsvg/_dzsvg_svgs');
var helpersDZSVG = require('./js_dzsvg/_dzsvg_helpers');
var helpersDZS = require('./js_common/_dzs_helpers');
var playerAdFunctions = require('./js_dzsvg/_player_ad_functions');
var videoElementFunctions = require('./js_dzsvg/_video-element-functions');
var _secondCon = require('./js_dzsvg/components/_second_con');


var ConstantsDzsvg = require('./configs/Constants').constants;
setTimeout(function () {

  if (window.dzsvg_settings) {

  }
  // console.info('Object.hasOwnProperty(\'assign\') - ',Object.hasOwnProperty('assign'));
  if (Object.hasOwnProperty('assign')) {

    window.dzsvg_settings = Object.assign(dzsvg_default_settings, window.dzsvg_settings)
  }
}, 2);


class DzsVideoPlayer {
  constructor(argThis, argOptions, $) {

    this.argThis = argThis;
    this.argOptions = argOptions;
    this.$ = $;

    this.cthis = null;
    this.initOptions = {};
    this.parentGallery = null; // -- parent dzsvg


    this._videoElement = null;
    this._vpInner = null;
    this._fullscreenVideoElement = null; // -- the video element might be different then the video element ( ie. vimeo )
    this._controlsRight = null;
    this._volumeControls = null;
    this._volumeControls_real = null;
    this.$adContainer = null

    // -- dimensions
    this.bufferedWidthOffset = 0;
    this.original_scrubwidth = 0;
    this.volumeWidthOffset = 0;

    this.totalWidth = 0;
    this.totalHeight = 0;
    this.videoWidth = 0;
    this.videoHeight = 0;


    this.currentPlayerId = '';
    this.dataSrc = '';
    this.dataType = ''; // -- type

    this.paused = true;
    this.suspendStateForLoop = false;
    this.wasPlaying = false;
    this.initial_played = false;
    this.is_muted_for_autoplay = false; // -- is muted only for autoplay purposes
    this.shouldStartMuted = false;
    this.isPartOfAnGallery = false;
    this.isGalleryHasOneVideoPlayerMode = false;
    this.isAd = false;
    this.isHadFirstInteraction = false;
    this.hasCustomSkin = true; // -- has custom skin or the iframe skin

    this.queue_goto_perc = 0; // -- seek to

    this.autoplayVideo = 'off';
    this.youtube_queue_change_quality = 'off';
    this.isLoop = false

    // -- ads
    this.$adSkipCon = null;
    this.ad_status = 'undefined'
    this.ad_link = null;
    this.ad_array = [];
    this.isAdPlaying = false

    this.dash_inter_check_sizes = 0;

    this.vimeo_url = '';

    this.volumeClass = new (require('./js_dzsvg/components/_volume').VolumeControls)(this);
    this.volumeLast = null;
    this.volumeDefault = null;

    this.classInit();
  }

  classInit() {


    var cthis
      , _cmedia
    ;
    var the_player_id = ''; // -- this is set only if the player actually has an id

    var natural_videow = 0
      , natural_videoh = 0
      , last_videoWidth = 0
      , last_videoHeight = 0;
    var video;
    var aux = 0;
    var aux2 = 0;
    var is_fullscreen = 0;
    var inter_videoReadyState // interval to check for time
      , inter_checkytadend // interval to check on when the youtube video ad has ended
      , inter_removeFsControls // interval to remove fullscreen controls when no action is detected
      , inter_mousedownscrubbing = 0 // interval to apply mouse down scrubbing on the video
    ;
    var infoPosX;
    var infoPosY;
    var fScreenControls
      , playcontrols
      , _volumeControls
      , _volumeControls_real
      , info
      , infotext
      , scrubbar
      , _scrubBg
      , _timetext
      , _btnhd
      , _controlsBackground = null
      , _muteControls = null

    ;
    var played = false
      , mouseover = false // -- the mouse is over the vplayer
      , google_analytics_sent_play_event = false
      , volume_mouse_down = false
      , scrub_mouse_down = false
      , controls_are_hovered = false
      , view_sent = false
      , fullscreen_just_pressed = false
      , play_commited = false // -- this will apply play later on
      , inited = false
      , inited_readyVideo = false
      , vimeo_is_ready = false
    ;

    var scrubbar_moving_x = 0
      , scrubbar_moving = false // -- touch
    ;


    var totalDuration = 0;
    var time_curr = 0;
    var dataOriginalSrc = '';
    var data_sourceVp = '';
    var dataVideoDesc = '';
    var dataOriginalType = ''; // -- type

    var video_title = '';

    //responsive vars
    var _rparent
      , currScale = 1
    ;
    var ww
      , wh
    ;
    var yt_qualArray = []
      , yt_qualCurr
      , hasHD = false
    ;

    var is360 = false;

    var arrTags = [];


    var bufferedLength = -1
      , volumeLength = 0
      , scrubbg_width = 0
    ;
    var time_counter_skipad = 0
      , lasttype = ''
      , inter_time_counter_skipad = 0
      , inter_check_yt_iframe_ready = 0
      , inter_clear_playpause_mistake = 0
    ;

    var action_video_end = null
      , action_video_play = null
      , action_video_pause = null
      , action_video_view = null
    ;

    var busy_playpause_mistake = false
    ;

    var _controls_fs_canvas;

    var vimeo_data;


    var dzsvg_translate_youcanskipto = 'you can skip to video in ';
    var translate_skipad = 'Skip Ad';

    var inter_10_secs_contor = 0
      , inter_5_secs_contor = 0
      , inter_60_secs_contor = 0
    ;

    var video_pattern_w_arr = []
      , video_pattern_h_arr = []
    ;


    var Dzsvg360 = require('./js_dzsvg/_dzsvg_360');


    if (window.dzsvg_translate_youcanskipto != undefined) {
      dzsvg_translate_youcanskipto = window.dzsvg_translate_youcanskipto;
    }
    if (window.dzsvg_translate_skipad) {
      translate_skipad = window.dzsvg_translate_skipad;
    }

    var $ = this.$;
    var o = this.argOptions;
    cthis = $(this.argThis);
    var selfClass = this;

    selfClass.cthis = cthis;
    selfClass.initOptions = o;

    // -- class proto
    // var vpClass = new dzsvgVideoPlayer(cthis);


    // console.info('o - ', o, cthis);

    if (cthis.attr('id')) {
      the_player_id = cthis.attr('id');
    } else {
      if (cthis.attr('data-player-id')) {
        the_player_id = cthis.attr('data-player-id');
      }

    }


    if (typeof cthis.attr('id') != 'undefined' && cthis.attr('id')) {
      selfClass.currentPlayerId = cthis.attr('id');
    } else {
      selfClass.currentPlayerId = 'dzsvp' + parseInt(Math.random() * 10000, 10)
    }


    if (cthis.parent().parent().parent().hasClass('videogallery')) {
      selfClass.parentGallery = cthis.parent().parent().parent();
    }


    //console.log(cthis, cthis.css('width'));

    // -- determine autoplay
    selfClass.autoplayVideo = o.autoplay;


    if (o.init_on == 'init') {
      init();
    }
    if (o.init_on == 'scroll') {


      $(window).on('scroll.' + selfClass.currentPlayerId, handle_scroll);
      handle_scroll();
    }


    function init() {
      // -- @order - first function
      //console.info('init()', cthis);


      // -- external function calls
      selfClass.get_responsive_ratio = get_responsive_ratio;
      selfClass.player_user_had_first_interaction = player_user_had_first_interaction;
      selfClass.pauseMovie = pauseMovie;
      selfClass.setup_skipad = setup_skipad;
      selfClass.seek_to_perc = seek_to_perc;
      selfClass.playMovie = playMovie;
      selfClass.playMovie_visual = playMovie_visual;
      selfClass.pauseMovie_visual = pauseMovie_visual;
      selfClass.check_if_ad_must_be_played = () => {
        playerAdFunctions.check_if_ad_must_be_played(selfClass);
      };
      selfClass.check_if_hd_available = check_if_hd_available;
      selfClass.handleVideoEnd = handleVideoEnd;
      selfClass.volume_setInitial = selfClass.volumeClass.volume_setInitial;
      selfClass.volume_mute = player_volumeMute;
      selfClass.fullscreenHandleChange = handleFullscreenChange;
      selfClass.setupVolume = volume_setupVolumePerc;


      if (cthis.hasClass('vplayer-tobe')) {

        cthis.removeClass('vplayer-tobe');
        cthis.addClass('vplayer');

        //console.log(autoplay, cthis);


        if (o.settings_disableVideoArray != 'on') {
          dzsvp_players_arr.push(cthis);
        }


        inited = true;

        $(window).off('scroll.' + selfClass.currentPlayerId);


        // -- get from attr
        helpersDZSVG.playerHandleDeprecatedAttrSrc(cthis);
        if (cthis.attr('data-sourcevp')) {
          selfClass.dataSrc = cthis.attr('data-sourcevp');
          dataOriginalSrc = cthis.attr('data-sourcevp');
        }
        if (cthis.attr('data-type')) {
          selfClass.dataType = cthis.attr('data-type');
          dataOriginalType = cthis.attr('data-type');
        } else {
          if (o.type) {
            dataOriginalType = o.type;
            selfClass.dataType = o.type;
          }
        }
        // -- get from attr END


        if (selfClass.dataType == 'normal' || selfClass.dataType == 'video') {
          selfClass.dataType = 'selfHosted';
        }

        // console.log('cthis - ', cthis, selfClass.dataType, 'o.type - ', o.type);

        const videoTypeAndSource = helpersDZSVG.detect_video_type_and_source(selfClass.dataSrc, null, selfClass.cthis);


        // console.log('dataOriginalType - ', dataOriginalType);
        if (dataOriginalType === '' || dataOriginalType === 'detect') {
          if (typeof selfClass.dataSrc) {
            cthis.attr('data-type', videoTypeAndSource.type);
            selfClass.dataType = videoTypeAndSource.type;


            if (o.playfrom == 'default') {
              if (videoTypeAndSource.playFrom) {
                o.playfrom = videoTypeAndSource.playFrom;
              }
            }

          }
        }

        helpersDZSVG.configureAudioPlayerOptionsInitial(cthis, o, selfClass);

        if (o.action_video_end) {
          action_video_end = o.action_video_end;
        }
        if (o.action_video_view) {
          action_video_view = o.action_video_view;
        }

        if (selfClass.hasCustomSkin) {
          selfClass.cthis.addClass('has-custom-controls');
        }


        selfClass.original_scrubwidth = o.design_scrubbarWidth;


        var aux = '';
        if (cthis.attr('data-ad-array')) {
          aux = cthis.attr('data-ad-array');
          selfClass.ad_array = helpersDZSVG.sanitizeDataAdArrayStringToArray(aux);
        }


        // -- decode after parsing json
        for (var lab in selfClass.ad_array) {
          // console.warn('selfClass.ad_array  lab - ', selfClass.ad_array[lab]);
          selfClass.ad_array[lab].source = String(selfClass.ad_array[lab].source).replace(/{{doublequot_fordzsvgad}}/g, '"')
        }


        // -- we do not need the attr anymore.. hide it
        cthis.attr('data-sourcevp', '');
        cthis.data('data-sourcevp', selfClass.dataSrc);
        cthis.data('data-sourcevp-original', dataOriginalSrc);


        if (selfClass.dataType == 'vimeo' || selfClass.dataType == 'youtube' || selfClass.dataType == 'dash') {
          selfClass.dataSrc = videoTypeAndSource.source;
        }


        o.type = selfClass.dataType;

        //console.info('type is ',selfClass.dataType);

        if (cthis.attr('data-is-360') == 'on') {
          is360 = true;
        }

        // console.info('is360 - ',is360);
        if (selfClass.dataType == 'audio') {

          // -- on no circumstance audio can play
          if (helpersDZSVG.is_mobile()) {
            selfClass.autoplayVideo = 'off';
            o.autoplay = 'off';
          }

        }

        cthis.addClass('type-' + selfClass.dataType);

        lasttype = selfClass.dataType;

        if (selfClass.dataType == 'vimeo') {
          if (o.vimeo_is_chromeless == 'on') {
            cthis.addClass('vimeo-chromeless');
          }
        }

// console.info('selfClass.dataType -> ',selfClass.dataType);
        if (selfClass.dataType != 'selfHosted' && selfClass.dataType != 'video') {
          is360 = false;
        }
        // console.info('is360 -> ',is360);
        if (cthis.attr('data-adlink')) {
          selfClass.ad_link = cthis.attr('data-adlink');
        }
        _rparent = cthis.parent();


        if (selfClass.dataType == 'youtube') {
          if (window._global_youtubeIframeAPIReady == false && dzsvp_yt_iframe_settoload == false) {
            helpersDZSVG.load_outside_script(ConstantsDzsvg.YOUTUBE_IFRAME_API);
            dzsvp_yt_iframe_settoload = true;
          }
        }

//                    console.info(cthis, o, o.settings_disableControls);

        if (selfClass.dataType == 'inline') {

          //console.info(o);

          // console.info('o.htmlContent - ',o.htmlContent);
          if (o.htmlContent != '') {
            cthis.html(o.htmlContent);
          }

          if (cthis.children().length > 0) {
            var _cach = cthis.children().eq(0);
            if (_cach.get(0) != undefined) {
              if (_cach.get(0).nodeName == 'IFRAME') {
                _cach.attr('width', '100%');
                _cach.attr('height', '100%');
              }
            }
          }
        }


        if (selfClass.isAd) {
//                console.info(cthis);

          if (selfClass.dataType == 'youtube' && helpersDZSVG.is_touch_device() && $(window).width() < 700) {
            cthis.addClass('is-touch-device type-youtube');

          }
          o.settings_video_overlay = 'on';

          if (helpersDZSVG.is_mobile()) {

          }
        }


        setup_basicStructure();
        // console.info('selfClass.dataSrc - ',selfClass.dataSrc);


        if (cthis.get(0)) {
          //cthis.get(0).fn_change_mainColor = fn_change_mainColor; cthis.get(0).fn_change_mainColor('#aaa');
          cthis.get(0).fn_change_color_highlight = fn_change_color_highlight; //cthis.get(0).fn_change_mainColor('#aaa');

          cthis.get(0).api_handleResize = handleResize;
          cthis.get(0).api_seek_to_perc = seek_to_perc;

          cthis.get(0).api_currVideo_refresh_fsbutton = (arg) => {
            helpersDZSVG.player_controls_drawFullscreenBarsOnCanvas(selfClass, _controls_fs_canvas, arg);
          }
          cthis.get(0).api_reinit_cover_image = reinit_cover_image;
          cthis.get(0).api_restart_video = restart_video;
          cthis.get(0).api_change_media = change_media;


          cthis.get(0).api_ad_end = () => {
            playerAdFunctions.adEnd(selfClass);
          };
          cthis.get(0).api_action_set_video_end = function (arg) {
            action_video_end = arg;
          };
          cthis.get(0).api_action_set_video_view = function (arg) {
            action_video_view = arg;
          };
          cthis.get(0).api_action_set_video_play = function (arg) {
            action_video_play = arg;
          };
          cthis.get(0).api_action_set_video_pause = function (arg) {
            action_video_pause = arg;
          };

          //console.log('ceva');
        }


        if (o.settings_big_play_btn == 'on') {
          var auxbpb = '<div class="big-play-btn">';
          auxbpb += helpersSvg.svg_aurora_play_btn;
          auxbpb += '</div>';

          if (cthis.find('.controls').length) {
            cthis.find('.controls').before(auxbpb);
          } else {
            cthis.append(auxbpb);
          }


          cthis.find('.big-play-btn').on('click', click_videoOverlay);

          cthis.addClass('has-big-play-btn');
        } else {

          cthis.addClass('not-has-big-play-btn');
        }


        if (o.cueVideo == 'on' || ((!helpersDZSVG.is_ios() || o.settings_ios_usecustomskin == 'on') && (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'youtube' || selfClass.dataType == 'vimeo'))) {

          if (selfClass.dataType == 'youtube') {
            inter_check_yt_iframe_ready = setInterval(check_if_yt_iframe_ready, 100);
          } else {
            init_readyControls(null, {
              'called_from': 'init.. cue video'
            });
          }
        } else {

          resizePlayer(selfClass.videoWidth, selfClass.videoHeight);
          cthis.bind('click', init_readyControls);

          cthis.addClass('dzsvp-loaded');

        }

        if (o.cueVideo != 'on') {


          //--------------normal
          if ((!helpersDZSVG.is_ios() || o.settings_ios_usecustomskin == 'on')) {
          }


        } else {
          //console.log(selfClass.dataType);

        }


        setInterval(check_one_sec_for_adsOrTags, 1000);
        check_one_sec_for_adsOrTags();


        handleResize();
      }

      // console.info('o.action_video_contor_10secs - ',o.action_video_contor_10secs);
      if (inter_10_secs_contor == 0 && o.action_video_contor_10secs) {
        inter_10_secs_contor = setInterval(count_10secs, 10000);
      }
      if (inter_60_secs_contor == 0 && o.action_video_contor_60secs) {
        inter_60_secs_contor = setInterval(count_60secs, 30000);
      }

      // console.info(o,inter_5_secs_contor,o.action_video_contor_5secs);
      if (inter_5_secs_contor == 0 && o.action_video_contor_5secs) {
        inter_5_secs_contor = setInterval(count_5secs, 3000);
        setTimeout(function () {

          count_5secs();
        }, 500)
      }


      //console.info(cthis, selfClass.autoplayVideo, selfClass.autoplayVideo);
    }

    function setup_basicStructure() {

      // -- setup vp-inner
      if (!cthis.children('.vp-inner').length) {


        //&& selfClass.dataType != 'vimeo' q q
        if (selfClass.dataType != 'inline') {
          if (selfClass.dataType == 'vimeo') {
            if (o.settings_big_play_btn == 'on') {
              cthis.append('<div class="vp-inner ' + o.design_skin + '"></div>');
            } else {

              cthis.prepend('<div class="vp-inner ' + o.design_skin + '"></div>');
            }
          } else {


            cthis.append('<div class="vp-inner ' + o.design_skin + '"></div>');
          }

          selfClass._vpInner = cthis.children('.vp-inner').eq(0);
        } else {
          selfClass._vpInner = selfClass.cthis;
        }
      }

      // console.log('selfClass.hasCustomSkin - ', selfClass.hasCustomSkin);
      if (selfClass.hasCustomSkin) {
        setup_customControls();
      }
    }

    function setup_customControls() {


      var str_scrubbar = '<div class="scrubbar">';
      str_scrubbar += '<div class="scrub-bg"></div><div class="scrub-buffer"></div><div class="scrub">';
      if (o.design_skin == 'skin_aurora') {
        ;
      }

      str_scrubbar += '</div><div class="scrubBox"></div><div class="scrubBox-prog"></div>';
      str_scrubbar += '</div>';


      if (o.design_skin == 'skin_pro') {

        if (!(selfClass.dataType == 'vimeo' && o.vimeo_is_chromeless != 'on')) {

          // console.info("LETS ADD TIHS");
          if (selfClass._vpInner) {
            selfClass._vpInner.append(str_scrubbar);
          }
        }

      }


      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'youtube') {
        if (selfClass._vpInner) {
          selfClass._vpInner.prepend('<div class="mute-indicator"><i class="the-icon">' + helpersSvg.svg_mute_icon + '</i> <span class="the-label">' + 'muted' + '</span></div>')
        }
      }

      var str_controls = '<div class="controls"></div>';

      if (cthis.find('.cover-image').length > 0) {
        //console.info('ceva',str_controls);
        cthis.find('.cover-image').eq(0).before(str_controls);
      } else {

        if (selfClass._vpInner) {

          selfClass._vpInner.append(str_controls);
          // console.info("ADDED CONTROLS");
        }
      }


      setTimeout(function () {
        cthis.addClass('cover-image-loaded');
      }, 600);

      selfClass._controlsDiv = cthis.find('.controls');


      if (o.design_skin == 'skin_aurora') {
        //console.info('ceva');


        if (helpersDZSVG.is_touch_device()) {

          //cthis.append('<div class="touch-play-btn"></div>');
        }

      }

      //console.log('ceva');


      //console.log(videoWidth);
      selfClass.totalWidth = selfClass.videoWidth;
      selfClass.totalHeight = selfClass.videoHeight;

      //console.log(cthis, selfClass.videoWidth);
      cthis.css({
        //'width': selfClass.videoWidth,
        //'height': selfClass.videoHeight
      })

      if (selfClass.videoWidth == '100%') {

      }


      if (video_title == '') {

        //console.warn(cthis.children());
      }

      //console.warn(video_title);


      //console.log(selfClass.dataType);


      if (o.design_skin == 'skin_pro' || o.design_skin == 'skin_aurora') {
        selfClass._controlsDiv.append('<div class="controls-right"></div>');
      }

      if (selfClass._controlsDiv.find('.controls-right').length) {
        selfClass._controlsRight = selfClass._controlsDiv.find('.controls-right');
      }

      // console.info("o -3 ",o, o.vimeo_is_chromeless, selfClass.dataType);
      if ((selfClass.dataType != 'vimeo' || o.vimeo_is_chromeless == 'on') && selfClass.dataType != 'image' && selfClass.dataType != 'inline') {

        // console.info("YES");
        var aux34 = '<div class=""></div>';


        var struct_bg = '<div class="background"></div>';
        var struct_playcontrols = '<div class="playcontrols-con"><div class="playcontrols"></div></div>';


        var struct_timetext = '<div class="timetext"><span class="curr-timetext"></span><span class="total-timetext"></span></div>';


        var struct_fscreen = '<div class="fscreencontrols"></div>';

        aux34 += '';
        selfClass._controlsDiv.append(struct_bg);
        selfClass._controlsDiv.append(struct_playcontrols);
        if (o.design_skin != 'skin_pro') {
          selfClass._controlsDiv.append(str_scrubbar);
        }
        selfClass._controlsDiv.append(struct_timetext);

        if (selfClass._controlsRight) {
          selfClass._controlsRight.append(struct_fscreen);
        } else {
          selfClass._controlsDiv.append(struct_fscreen);
        }
        selfClass.volumeClass.constructVolumeInPlayer();


        if (o.design_skin == 'skin_avanti') {
          selfClass._controlsDiv.append('<div class="mutecontrols-con"><div class="btn-mute">' + helpersSvg.svg_mute_btn + '</div></div>');

          _muteControls = selfClass._controlsDiv.find('.mutecontrols-con').eq(0);
        }
      }


      if (selfClass._controlsRight) {

        selfClass._controlsDiv.append(selfClass._controlsRight);
      }


      _timetext = cthis.find('.timetext').eq(0);


      if (o.settings_extrahtml_before_right_controls) {
        // console.warn('aux -> ',aux);

        // console.info("o.settings_extrahtml_before_right_controls -> > ",o.settings_extrahtml_before_right_controls,_controlsRight);
        o.settings_extrahtml_before_right_controls = String(o.settings_extrahtml_before_right_controls).replace('{{svg_quality_icon}}', helpersSvg.svg_quality_icon);

        if (selfClass._controlsRight) {

          selfClass._controlsRight.prepend(o.settings_extrahtml_before_right_controls);
        } else {

          if (_timetext) {

            _timetext.after(o.settings_extrahtml_before_right_controls);
          }
        }
      }

      _controlsBackground = selfClass._controlsDiv.find('.background').eq(0);

      if (selfClass.dataType == 'image') {
        cthis.attr('data-img', selfClass.dataSrc);
      }

      if (cthis.children('.vplayer-logo')) {
        cthis.append(cthis.children('.vplayer-logo'));
      }


      if (cthis.children('.extra-controls')) {
        if (o.design_skin == 'skin_aurora') {
          cthis.children('.extra-controls').children().each(function () {
            var _t = $(this);

            if (_t.html().indexOf('{{')) {
              _t.html(String(_t.html()).replace('{{svg_embed_icon}}', helpersSvg.svg_embed));
            }
            if (_t.get(0).outerHTML.indexOf('dzsvg-multisharer-but') > -1) {
              helpersDZSVG.dzsvg_check_multisharer();
            }

            cthis.find('.timetext').eq(0).after(_t);
          });

        }
      }


      if (cthis.attr('data-img')) {
        selfClass._vpInner.prepend('<div class="cover-image from-type-' + selfClass.dataType + '"><div class="the-div-image" style="background-image:url(' + cthis.attr('data-img') + ');"/></div>');
      }

      if (cthis.attr('data-loop') == 'on') {
        selfClass.isLoop = true;
      }


      if (selfClass.dataType == 'image') {

        cthis.addClass('dzsvp-loaded');


        if (selfClass.ad_link) {
          selfClass.cthis.children().eq(0).css({'cursor': 'pointer'})
          selfClass.cthis.children().eq(0).bind('click', function () {
            if (selfClass.cthis.find('.controls').eq(0).css('pointer-events') != 'none') {
              window.open(selfClass.ad_link);
              selfClass.ad_link = null;
            }
          })
        }
        setup_skipad();
        return;
      }


      // console.info(selfClass.dataType);
      if (selfClass.dataType == 'inline') {
        cthis.find('.cover-image').bind('click', function () {
          $(this).fadeOut('slow');
        });
        setup_skipad();

        var aux_preloader = '<div class="dzsvg-preloader preloader-fountain" > <div id="fountainG_1" class="fountainG"></div> <div id="fountainG_2" class="fountainG"></div> <div id="fountainG_3" class="fountainG"></div> <div id="fountainG_4" class="fountainG"></div> </div>';

        if (cthis.find('.cover-image').length) {
          cthis.find('.cover-image').before(aux_preloader);
        } else {
          cthis.append(aux_preloader);
        }

        cthis.addClass('dzsvp-loaded');

        setTimeout(function () {

          cthis.addClass('dzsvp-really-loaded');


        }, 2000);


        get_responsive_ratio({
          'called_from': 'init .. inline'
        });
        handleResize();
        setTimeout(function () {

          handleResize();
        }, 1000);
        $(window).on('resize', handleResize);

        return;
      }


      if (selfClass.dataType == 'youtube') {

        get_responsive_ratio({
          'called_from': 'init .. youtube'
        });
      }
      if (selfClass.dataType === 'selfHosted') {

        if (o.settings_disableControls === 'on') {
          // -- for youtube ads we force enable the custom skin because we need to know when the video ended
          o.cueVideo = 'on';
          o.settings_youtube_usecustomskin = 'on';

          if (helpersDZSVG.is_mobile()) {

            selfClass.autoplayVideo = 'off';
          }
        }
        if (selfClass.isAd && helpersDZSVG.is_mobile() && cthis.attr('data-adskip_delay')) {
          helpersDZSVG.player_ad_setupMobileNotice(selfClass);
        } else {
          setup_skipad();
        }
      }

      if (selfClass.dataType === 'vimeo') {

        // console.info('selfClass._controlsDiv - ',selfClass._controlsDiv,selfClass._controlsDiv.children());
        setup_skipad();
      }
      if (selfClass.dataType === 'youtube') {
        if (o.settings_disableControls === 'on') {
          // -- for youtube ads we force enable the custom skin because we need to know when the video ended
          o.cueVideo = 'on';
          o.settings_youtube_usecustomskin = 'on';
          if (helpersDZSVG.is_mobile()) {
            selfClass.autoplayVideo = 'off';
          }
        }


        if (selfClass.isAd && helpersDZSVG.is_mobile() && (cthis.attr('data-adskip_delay') || selfClass.initOptions.settings_youtube_usecustomskin !== 'on')) {
          helpersDZSVG.player_ad_setupMobileNotice();
        } else {
          setup_skipad();
        }
        // console.info("SETTING UP SKIP AD");
      }
      info = cthis.find('.info');
      infotext = cthis.find('.infoText');

      ////info


      var structPlayControls = '';
      playcontrols = cthis.find('.playcontrols');


      structPlayControls = helpersDZSVG.player_controls_generatePlayCon(o);

      playcontrols.append(structPlayControls);


      scrubbar = cthis.find('.scrubbar');
      // scrubbar.append(aux_scrub);

      _scrubBg = scrubbar.children('.scrub-bg');
//                    console.info(scrubbar, _scrubBg);


      fScreenControls = cthis.find('.fscreencontrols');

      aux = '<div class="full">';


      if (o.design_skin == 'skin_aurora' || o.design_skin == 'skin_default' || o.design_skin == 'skin_white') {
        aux += helpersSvg.svg_full_icon;
      }


      aux += '</div><div class="fullHover"></div>';


      if (o.design_skin == 'skin_reborn') {
        aux += '<div class="full-tooltip">FULLSCREEN</div>';
      }


      fScreenControls.append(aux);


      if (o.design_skin == 'skin_pro' || o.design_skin == 'skin_bigplay') {
        playcontrols.find('.pauseSimple').eq(0).append('<div class="pause-part-1"></div><div class="pause-part-2"></div>');
        fScreenControls.find('.full').eq(0).append('<canvas width="15" height="15" class="fullscreen-button"></canvas>');

        _controls_fs_canvas = fScreenControls.find('.full').eq(0).find('canvas.fullscreen-button').eq(0)[0];
        if (_controls_fs_canvas != undefined) {
          helpersDZSVG.player_controls_drawFullscreenBarsOnCanvas(selfClass, _controls_fs_canvas, o.controls_fscanvas_bg);
          $(_controls_fs_canvas).bind('mouseover', handleMouseover);
          $(_controls_fs_canvas).bind('mouseout', handleMouseout);
        }
      }


      if (selfClass.cthis.children('.videoDescription').length > 0) {
        dataVideoDesc = selfClass.cthis.children('.videoDescription').html();
        selfClass.cthis.children('.videoDescription').remove();
      }


      if (cthis.attr('data-videoTitle')) {
        if (selfClass._vpInner) {
          selfClass._vpInner.append('<div class="video-description"></div>')

        }


        cthis.find('.video-description').eq(0).append('<div class="video-title">' + cthis.attr('data-videoTitle') + '</div>');
        if (o.video_description_style == 'show-description' && dataVideoDesc) {
          cthis.find('.video-description').eq(0).append('<div class="video-subdescription">' + dataVideoDesc + '</div>');
        }
        // cthis.find('.video-subdescription').eq(0).css('width', (0.7 * selfClass.videoWidth));
        video_title = cthis.attr('data-videoTitle');
      }

      // console.info('dataVideoDesc -> ',dataVideoDesc);

    }


    function init_readyControls(e, pargs) {


      var margs = {
        'reset_responsive_ratio': false
        , 'check_source': true
        , 'called_from': 'default'
      };
      // console.warn('get_responsive_ratio()',pargs, o.responsive_ratio);

      if (pargs) {
        margs = $.extend(margs, pargs);
      }
      // console.log('%cinit_readyControls() -2 ',ConstantsDzsvg.DEBUG_STYLING_2,margs, cthis);


      var _c = cthis;
      _c.unbind();

      if (_c.attr('data-type') == 'youtube') {

        selfClass.dataSrc = helpersDZSVG.youtube_sanitize_url_to_id(selfClass.dataSrc);
      }


      var argsForVideoSetup = {}

      //console.log(cthis.find('.preview'))


      //console.info('type is ', selfClass.dataType, selfClass.dataSrc);


      // -- ios video setup

      if (o.settings_ios_usecustomskin !== 'on' && helpersDZSVG.is_ios()) {

        if (selfClass.dataType == 'selfHosted') {

          argsForVideoSetup.usePlayInline = true;
          argsForVideoSetup.useCrossOrigin = true;
        }
        if (selfClass.dataType == 'vimeo') {
          _c.children().remove();
          var src = selfClass.dataSrc;
          _c.append('<iframe width="100%" height="100%" src="//player.vimeo.com/video/' + src + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allow="autoplay;fullscreen" style=""></iframe>');

        }


        if (o.responsive_ratio == 'default') {
          // console.info("YES");
          get_responsive_ratio({
            'called_from': 'init_readyControls .. ios'
          });
          ;
          o.responsive_ratio = 0.5625;
        }

        cthis.addClass('dzsvp-loaded');

        handleResize();


        // -- our job on the iphone / ipad has been done, we exit the function.
      }
      // -- end ios setup


      // -- selfHosted
      if ((!helpersDZSVG.is_ios() || o.settings_ios_usecustomskin == 'on')) {

        // -- selfHosted video on modern browsers
        if (o.settings_enableTags == 'on') {
          cthis.find('.dzstag-tobe').each(function () {
            var _tagElement = $(this);
            helpersDZSVG.tagsSetupDom(_tagElement);
          })
          arrTags = cthis.find('.dzstag');
        }
        aux = '';
        if (selfClass.dataType === 'audio') {
          if (selfClass.cthis.attr('data-audioimg') != undefined) {
            aux = '<div style="background-image:url(' + selfClass.cthis.attr('data-audioimg') + ')" class="div-full-image from-type-audio"/>';
            selfClass._vpInner.prepend(aux);
          }
        }
        if (selfClass.dataType == 'selfHosted') {

          if (o.cueVideo != 'on') {
            // o.autoplay = 'off';
            selfClass.autoplayVideo = 'off';

            argsForVideoSetup = {
              'preload': 'metadata',
              'called_from': 'init_readyControls .. cueVideo off'
            };

          } else {

            if (o.preload_method) {
              argsForVideoSetup.preload = o.preload_method;
              argsForVideoSetup.called_from = 'init_readyControls .. cueVideo on';
            }
          }
        }


        //console.info(selfClass.dataType,o.settings_youtube_usecustomskin)


        // --- type youtube
        if (selfClass.dataType == 'youtube') {
          // -- youtube
          argsForVideoSetup.youtube_useDefaultSkin = (o.settings_youtube_usecustomskin != 'on' || (o.settings_ios_usecustomskin != 'on' && helpersDZSVG.is_ios()));


          // console.log('window.YT - ', window.YT);
          if (!window.YT) {

            // -- we will need to invoke iframe api
            helpersDZSVG.load_outside_script(ConstantsDzsvg.YOUTUBE_IFRAME_API);
            dzsvp_yt_iframe_settoload = true;
            setTimeout(function () {
              init_readyControls(null, {
                'called_from': 'retry.. no youtube api'
              })
            }, 1000)
            return false;
          }
        }


        if (selfClass.dataType == 'dash') {
          helpersDZSVG.dash_setupPlayer();

        }


        if (margs.called_from == 'change_media') {
          argsForVideoSetup.isGoingToChangeMedia = true;
        }

        if (selfClass.dataType == 'youtube' && argsForVideoSetup.youtube_useDefaultSkin == false) {

          cthis.find('#the-media-' + selfClass.currentPlayerId).bind('mousemove', handle_mousemove);
        }

      }
      helpersDZSVG.generatePlayerMarkupAndSource(selfClass, argsForVideoSetup);


      // -- setup remainder

      if (selfClass.dataType == 'vimeo') {
        //console.log(video);
        //

        if (window.addEventListener) {
          window.addEventListener('message', vimeo_windowMessage, false);
        }

      }


      if (selfClass.autoplayVideo == 'on') {
        selfClass.wasPlaying = true;
      }

      get_responsive_ratio({
        'called_from': 'init .. readyControls'
      });
      ;


      if (margs.called_from != 'change_media' && String(margs.called_from).indexOf('retry') == -1) {
        init_final();
      }
      ;

      video = selfClass._videoElement;
    }


    function check_videoReadyState() {
      if (!selfClass._videoElement) {
        return;
      }
      // console.log('check_videoReadyState()', cthis, inited_readyVideo);

      helpersDZSVG.dzsvg_call_video_when_ready(o, selfClass._videoElement, init_readyVideo, vimeo_is_ready, inter_videoReadyState);
      setTimeout(() => {
        if (o.cue == 'on') {
          if (!inited_readyVideo) {
            init_readyVideo({
              'called_from': 'timeout .. readyvideo'
            })
          }
        }
      }, 10000);
//                console.log(selfClass._videoElement.readyState);
    }


    /**
     * this function will assign listeners to the player and selfClass.autoplayVideo if the selfClass.autoplayVideo is set to on
     * @param pargs parameters
     */
    function init_readyVideo(pargs) {
      // --
      //console.log(selfClass._videoElement.getAvailableQualityLevels());


      var margs = {

        'called_from': 'default'
      };

      if (pargs) {
        margs = $.extend(margs, pargs);
      }
      // console.info('%c init_readyVideo', 'background-color: #888dd8; color: #eeeeee;',"READY VIDEO", margs,cthis);


      inited_readyVideo = true;
      clearInterval(inter_videoReadyState);
      // if(video && selfClass._videoElement.getPlaybackQuality){
      //     console.info('getPlaybackQuality - ', selfClass._videoElement.getPlaybackQuality(), ' | state - ','init_readyVideo', ' | quality levels - ',selfClass._videoElement.getAvailableQualityLevels() );
      // }


      // console.log('init_readyVideo() - ', cthis, margs);


      // console.info('cthis.find(\'.dzsvg-feed-quality\') -> ',cthis.find('.dzsvg-feed-quality'));
      var _cas = cthis.find('.dzsvg-feed-quality');
      if (_cas.length) {
        cthis.addClass('has-multiple-quality-levels');


        var _cach = cthis.find('.quality-selector');
        var aux = _cach.find('.dzsvg-tooltip').html();

        var aux_opts = '';

        var added = false;


        var curr_qual_added = false;
        _cas.each(function () {
          var _t2 = $(this);


          aux_opts += '<div class="quality-option';


          // -- quality option has data-source ( _t2 )
          if (_t2.attr('data-source') == selfClass.dataSrc) {
            aux_opts += ' active';
            added = true;
          }


          aux_opts += '" data-val="' + _t2.attr('data-label') + '" data-source="' + selfClass.dataSrc + '">' + _t2.attr('data-label') + '</div>';
        })

        if (added == false) {

          aux_opts += '<div class="quality-option active ';


          aux_opts += '" data-val="' + o.settings_currQuality + '" data-source="' + selfClass.dataSrc + '">' + o.settings_currQuality + '</div>';

        }


        if (aux) {

          // aux = aux.replace('{{svg_quality_icon}}',helpersSvg.svg_quality_icon);
          aux = aux.replace('{{quality-options}}', aux_opts);


          _cach.find('.dzsvg-tooltip').html(aux);
        } else {
          console.warn('no aux ? ', aux, _cach);
        }


      }


      selfClass.volumeClass.volume_setInitial();


      if (selfClass.videoWidth == 0) {

        selfClass.videoWidth = cthis.width();
        selfClass.videoHeight = cthis.height();
      }

      cthis.addClass('dzsvp-loaded');
      if (o.gallery_object != null) {
        if (typeof (o.gallery_object.get(0)) != 'undefined') {
          o.gallery_object.get(0).api_video_ready();
        }
      }

      if (selfClass.dataType == 'youtube') {
        yt_qualCurr = selfClass._videoElement.getPlaybackQuality();

      }


      // console.info(selfClass.dataType);
      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'selfHosted') {
        if (o.default_playbackrate && o.default_playbackrate != '1') {

          // console.info('_cmedia - ',_cmedia);
          setTimeout(function () {

            // console.info('_cmedia - ',_cmedia);
            // console.info('video - ',video);
          }, 1000);
          if (selfClass._videoElement && selfClass._videoElement.playbackRate) {

            selfClass._videoElement.playbackRate = Number(o.default_playbackrate);
          }
        }
      }


      selfClass.videoWidth = cthis.outerWidth();
      selfClass.videoHeight = cthis.outerHeight();


//                console.log(cthis.width(), selfClass.videoWidth, selfClass.videoHeight);
      resizePlayer(selfClass.videoWidth, selfClass.videoHeight)


      var checkInter = setInterval(handleEnterFrame, 100);


      if (helpersDZSVG.is_mobile() && selfClass.isAd) {
        // selfClass.autoplayVideo = 'on';
      }


      // console.info('ready video -4','selfClass.autoplayVideo - ',selfClass.autoplayVideo)
      if (selfClass.autoplayVideo == 'on') {

        if (selfClass.dataType != 'vimeo') {

          playMovie({
            'called_from': 'autoplay - on'
          });
        }
      }

      if (o.playfrom != 'default') {
        if (o.playfrom == 'last' && the_player_id != '') {
          if (typeof Storage != 'undefined') {

            if (typeof localStorage['dzsvp_' + the_player_id + '_lastpos'] != 'undefined') {
//                                console.info(localStorage['dzsvp_'+the_player_id+'_lastpos'], selfClass.dataType, Number(localStorage['dzsvp_'+the_player_id+'_lastpos']));
              if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio') {
                selfClass._videoElement.currentTime = Number(localStorage['dzsvp_' + the_player_id + '_lastpos']);
              }
              if (selfClass.dataType == 'youtube') {
                selfClass._videoElement.seekTo(Number(localStorage['dzsvp_' + the_player_id + '_lastpos']));
                if (selfClass.wasPlaying == false) {
                  pauseMovie({
                    'called_from': '_init_readyVideo()'
                  });
                }
              }
            }
          }
        }

        if (isNaN(Number(o.playfrom)) == false) {
          if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio') {
            selfClass._videoElement.currentTime = o.playfrom;
          }
        }


      }


      handleEnterFrame({
        skin_play_check: true
      });


      // console.info('o.settings_disableControls - ',o.settings_disableControls,cthis);


      // -- we include this for both ads and selfHosted videos
      cthis.on('mouseleave', handleMouseout);
      cthis.on('mouseover', handleMouseover);


      cthis.on('click', '.mute-indicator', handle_mouse);

      selfClass._vpInner.on('click', '.controls .playcontrols', handleClickPlayPause);

      if (o.settings_disableControls != 'on') {
        // -- only for selfHosted videos

        if (cthis.hasClass('debug-target')) {
          console.info(cthis, playcontrols);
        }
        cthis.find('.controls').eq(0).bind('mouseover', handle_mouse);
        cthis.find('.controls').eq(0).bind('mouseout', handle_mouse);
        cthis.bind('mousemove', handle_mousemove);
        $(document).on('keyup.dzsvgp', handleKeyPress);


        // console.warn("HMM IOS");
        cthis.on('click', '.quality-option', handle_mouse);

        if (fScreenControls) {
          fScreenControls.off('click', fullscreenToggle);
          fScreenControls.on('click', fullscreenToggle);
        }

        if (scrubbar) {

          scrubbar.bind('click', handleScrub);
          scrubbar.bind('mousedown', handle_mouse);
          scrubbar.bind('mousemove', handleScrubMouse);
          scrubbar.bind('mouseout', handleScrubMouse);
        }
        cthis.bind('mouseleave', handleScrubMouse);


        selfClass._vpInner.find('.touch-play-btn').on('click touchstart', handleClickPlayPause);
        selfClass._vpInner.find('.mutecontrols-con').bind('click', click_mutecontrols);

        // console.info("HMM");
        // cthis.bind('keypress',handle_key);

        // console.info('[log] add fullscreen change event');


        document.addEventListener('fullscreenchange', handleFullscreenChange, false);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange, false);
        selfClass._videoElement.addEventListener('webkitendfullscreen', handleFullscreenEnd);
        selfClass._videoElement.addEventListener('endfullscreen', handleFullscreenEnd);


        //console.info('ios - ',helpersDZSVG.is_ios(),'android - ',helpersDZSVG.is_android());
        if (helpersDZSVG.is_mobile()) {
          if (selfClass.dataType == 'youtube') {
            if (o.settings_video_overlay == 'on') {

              cthis.find('.controls').eq(0).css('pointer-events', 'none');
              cthis.find('.controls .playcontrols').eq(0).css('pointer-events', 'auto');
            }
          }

        } else {

          if (is360) {
            o.settings_video_overlay = 'off';
          }
        }


      } else {
        // -- if we disableControls ( for ad for example )
        // -- disable controls except volume / probably because its a advertisment


        if (selfClass.isAd && selfClass.autoplayVideo == 'off') {

        }

        if (helpersDZSVG.is_ios() || helpersDZSVG.is_android()) {

          playcontrols.css({'opacity': 0.9});
          playcontrols.on('click', handleClickPlayPause);

          o.settings_hideControls = 'off';

          cthis.removeClass('hide-on-paused');
          cthis.removeClass('hide-on-mouse-out');


          if (selfClass.isAd) {
            // -- if this is an ad

            selfClass.autoplayVideo = 'on';
            o.autoplay = 'on';
            o.cue = 'on';


            cthis.find('.video-overlay').append('<div class="warning-mobile-ad">' + 'You need to click here for the ad for to start' + '</div>')

          }

        }
      }

      $(selfClass._videoElement).bind('play', handleVideoEvent);


      // console.info('o.settings_disableControls -',o.settings_disableControls, 'o.settings_video_overlay - ',  o.settings_video_overlay, cthis);


      if (helpersDZSVG.is_ios() && o.settings_ios_usecustomskin == 'off') {
        o.settings_video_overlay = 'off';
      }
      if (o.settings_video_overlay == 'on') {

        // console.info("HMM", cthis.find('.the-video').eq(0));

        var str_video_overlay = '<div class="video-overlay"></div>';
        cthis.find('.dzsvg-video-container').eq(0).after(str_video_overlay);

        cthis.on('click', '.video-overlay', click_videoOverlay);
        cthis.on('dblclick', '.video-overlay', fullscreenToggle);
      }

      if (o.video_description_style == 'gradient') {

        var aux3 = '<div class="video-description video-description-style-' + o.video_description_style + '"><div>';

        aux3 += dataVideoDesc;
        aux3 += '</div></div>';

        if (cthis.find('.big-play-btn').length) {

          cthis.find('.big-play-btn').eq(0).before(aux3);
        } else {

          if (cthis.find('.video-overlay').length) {

            cthis.find('.video-overlay').eq(0).after(aux3);
          } else {

            cthis.find('.controls').before(aux3);
          }
        }
      }

      //console.info('dataVideoDesc - ',dataVideoDesc);


      window.dzsvg_handle_mouse = handle_mouse;


      if (selfClass._volumeControls_real) {

        selfClass._volumeControls_real.bind('mousedown', handle_mouse);
        selfClass._volumeControls_real.bind('click', handleMouseOnVolume);
      }

      $(document).on('mouseup.dzsvg', window.dzsvg_handle_mouse);


      if (o.settings_hideControls == 'on') {
        selfClass._controlsDiv.hide();
      }


      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio') {

        selfClass._videoElement.addEventListener('ended', handleVideoEnd, false);
        if (helpersDZSVG.is_ios() && video && selfClass.isAd) {
          // console.info("ADDED END FULLSCREEN EVENT");
          selfClass._videoElement.addEventListener('webkitendfullscreen', function () {
            if (selfClass._videoElement.currentTime > selfClass._videoElement.duration * 0.75) {
              handleVideoEnd();
            }
          }, false);
        }
      }


      if (cthis.children('.subtitles-con-input').length || o.settings_subtitle_file) {
        setup_subtitle();
      }


      setTimeout(handleResize, 500);


      // -- if video were inside a gallery, the gallery would handle resize
      if (o.gallery_object == null) {
      }


      cthis.get(0).api_destroy_listeners = destroy_listeners;


    }


    function handle_scroll() {
      //console.log(loaded);
      if (inited == false) {


        var st = $(window).scrollTop();
        var cthis_ot = cthis.offset().top;

        var wh = window.innerHeight;


        // console.info('lets try to init video player - ', cthis_ot, st+wh);


        if (cthis_ot < st + wh + 150) {
          init();
        }


        return;
      } else {


      }

    }


    function check_one_sec_for_adsOrTags() {

      if (selfClass.isAdPlaying == false && (selfClass.paused == false)) {

        if (typeof selfClass.ad_array == 'object' && selfClass.ad_array.length > 0) {

          for (var i2 in selfClass.ad_array) {
            // console.info('ad vars - ','time_curr -> ', time_curr, selfClass.ad_array[i2].time, totalDuration);
            // console.info(totalDuration, time_curr >= selfClass.ad_array[i2].time * totalDuration, selfClass.ad_array[i2].time * totalDuration);


            var cach = selfClass.ad_array[i2];

            var cach_time = 0;


            if (cach.time) {
              cach_time = cach.time;
            }
            if (cach.source && totalDuration && time_curr >= cach_time * totalDuration) {

              playerAdFunctions.adSetup(selfClass, i2, {'called_from': 'check_one_sec_for_adsOrTags'});

            }
          }
        }

      }

      if (o.settings_enableTags == 'on') {
        check_tags();
      }

    }

    /**
     * change the media of the player
     * @param argmedia
     * @param pargs
     */
    function change_media(argmedia, pargs) {
      // -- @change media


      var margs = {
        'called_from': 'default'
        , 'type': 'selfHosted'
        , 'autoplay': 'off'
      }

      if (pargs) {
        margs = $.extend(margs, pargs);
      }

      // console.info(' selfClass.dataType - ',selfClass.dataType);
      // console.info(' margs.type - ',margs.type);
      // console.log('change_media() - lasttype - ', lasttype, 'margs - ', margs);


      lasttype = selfClass.dataType;

      // -- update with new types
      selfClass.dataSrc = argmedia;
      selfClass.dataType = margs.type;

      if (margs.autoplay) {
        selfClass.autoplayVideo = margs.autoplay;
      }
      helpersDZSVG.reinitPlayerOptions(selfClass, o);
      console.log('selfClass.hasCustomSkin [after reinit] - ', selfClass.hasCustomSkin)

      if (lasttype == margs.type) {

        // -- same type
        if (lasttype == 'selfHosted') {
          $(selfClass._videoElement).attr('src', argmedia);
          $(selfClass._videoElement).children('source').attr('src', argmedia);
        }
        if (lasttype == 'youtube') {
          if (selfClass.hasCustomSkin) {
            selfClass._videoElement.loadVideoById(helpersDZSVG.youtube_sanitize_url_to_id(argmedia));
          } else {
            if (selfClass._videoElement.loadVideoById) {
              selfClass._videoElement.loadVideoById(helpersDZSVG.youtube_sanitize_url_to_id(argmedia));
            } else {

              selfClass.dataSrc = helpersDZSVG.youtube_sanitize_url_to_id(argmedia);
              cthis.find('iframe').eq(0).attr('src', '//www.youtube.com/embed/' + selfClass.dataSrc + '?rel=0&showinfo=0')
            }
          }
        }
        if (lasttype == 'vimeo') {
          if (selfClass.hasCustomSkin) {
            var argsForVideoSetup = {
              called_from: 'change_media'
            }
            helpersDZSVG.generatePlayerMarkupAndSource(selfClass, argsForVideoSetup);
          } else {

            var str_source = 'https:' + '//player.vimeo.com/video/' + selfClass.dataSrc + '?api=1&color=' + o.vimeo_color + '&title=' + o.vimeo_title + '&byline=' + o.vimeo_byline + '&portrait=' + o.vimeo_portrait + '&badge=' + o.vimeo_badge + '&player_id=vimeoplayer' + selfClass.dataSrc + (selfClass.autoplayVideo == 'on' ? '&autoplay=1' : '');

            selfClass._vpInner.find('.vimeo-iframe').eq(0).attr('src', str_source)
          }

        }
      } else {

        // -- different types..

        // -- update types
        selfClass.dataType = margs.type;
        // console.info('change_media',argmedia,margs);

        cthis.find('video').each(function () {
          var _t2 = $(this);
          var errag = null;

          try {
            errag = this.pause();
            ;
          } catch (err) {
            console.log('cannot pause .. ', errag, err);
          }


          _t2.remove();
        });

        cthis.find('.the-video').remove();

        cthis.attr('data-sourcevp', argmedia);
        cthis.attr('data-type', margs.type);
        init_readyControls(null, {
          'called_from': 'change_media'
        });
        selfClass.dataSrc = argmedia;
      }


      lasttype = margs.type;

      if (selfClass.hasCustomSkin) {
        if (selfClass._vpInner.find('.controls').length == 0) {
          setup_customControls();
        }
      }


      if (margs.autoplay == 'on') {
        setTimeout(function () {

          playMovie({
            'called_from': 'change_media'
          });
        }, 300);
      }


    }


    function count_10secs() {
      if (o.action_video_contor_10secs && cthis.hasClass('is-playing')) {
        o.action_video_contor_10secs(cthis, video_title);
      }
    }

    function count_60secs() {
      if (o.action_video_contor_60secs && cthis.hasClass('is-playing')) {
        o.action_video_contor_60secs(cthis, video_title);
      }
    }

    function count_5secs() {
      if (o.action_video_contor_5secs) {
        o.action_video_contor_5secs(cthis, video_title);
      }
    }

    function restart_video() {


      //console.info(selfClass.dataType);
      if (selfClass.dataType == 'selfHosted') {
        seek_to_perc(0);
      }
      if (selfClass.dataType == 'vimeo') {

        seek_to_perc(0);
      }
      if (selfClass.dataType == 'youtube') {


        if (selfClass._videoElement && selfClass._videoElement.pauseVideo) {
          //console.info(selfClass.dataSrc);
        }

      }

      reinit_cover_image();
    }

    function check_if_yt_iframe_ready() {

//                console.info(selfClass.dataType);
      if ((window.YT && window.YT.Player) || window._global_youtubeIframeAPIReady) {
        init_readyControls(null, {
          'called_from': 'check_if_yt_iframe_ready'
        });
        clearInterval(inter_check_yt_iframe_ready);
      }
    }

    function setup_skipad(pargs) {


      var margs = {
        'called_from': 'default'
      }

      if (pargs) {
        margs = $.extend(margs, pargs);
      }


      if (selfClass.ad_status == 'first_played') {
        return false;
      }
      //console.info('setup_skipad()');
      if (selfClass.isAd) {
        var skipad_timer = 0;

        if (selfClass.dataType == 'image' || selfClass.dataType == 'inline') {
          skipad_timer = 0;
        }
        if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'youtube') {
          skipad_timer = 1001;
        }

        cthis.appendOnce('<div class="skipad-con"></div>', '.skipad-con');
        selfClass.$adSkipCon = cthis.find('.skipad-con').eq(0);

        if (typeof cthis.attr('data-adskip_delay') != 'undefined') {
          skipad_timer = Number(cthis.attr('data-adskip_delay'));
        }

        time_counter_skipad = skipad_timer;
//                    console.info(cthis, time_counter_skipad);
        if (skipad_timer != 1001) {
          setTimeout(function () {

            time_counter_skipad = 0;
            selfClass.$adSkipCon.html(translate_skipad);
            selfClass.$adSkipCon.bind('click', function () {
              if ($(this).attr('data-ad-status') == 'can_be_clicked_for_end_ad') {
                handleVideoEnd();
              }
            })
            selfClass.$adSkipCon.attr('data-ad-status', 'can_be_clicked_for_end_ad');
          }, skipad_timer * 1000);

          if (skipad_timer > 0) {
            inter_time_counter_skipad = setInterval(tick_counter_skipad, 1000);
          }
        }
      }

      selfClass.ad_status = 'first_played';
    }

    function tick_counter_skipad() {

//                console.info(cthis, time_counter_skipad);
      if (time_counter_skipad > 0) {
        time_counter_skipad = time_counter_skipad - 1;
        if (selfClass.$adSkipCon) {
          selfClass.$adSkipCon.html(dzsvg_translate_youcanskipto + time_counter_skipad);
          selfClass.$adSkipCon.attr('data-ad-status', 'ad_status_is_ticking');
        }

      } else {
        clearInterval(inter_time_counter_skipad);
      }
    }


    function fn_change_color_highlight(arg) {
      cthis.find('.scrub').eq(0).css({
        'background': arg
      })
      cthis.find('.volume_active').eq(0).css({
        'background': arg
      })
      cthis.find('.hdbutton-hover').eq(0).css({
        'color': arg
      })
    }

    function check_tags() {
      var roundTime = Number(time_curr);


      //console.log(arrTags.length);
      if (arrTags.length == 0) {
        return;
      }

      arrTags.removeClass('active');
      arrTags.each(function () {
        var _t = $(this);
        //console.log(_t);
        if (Number(_t.attr('data-starttime')) <= roundTime && Number(_t.attr('data-endtime')) >= roundTime) {
          _t.addClass('active');
        }
      })
      //jQuery('.dzstag[data-starttime=' + roundTime + ']').addClass('active');
    }


    function init_final() {


      if (cthis.get(0)) {
        if (!(cthis.get(0).externalPauseMovie)) {

          cthis.get(0).externalPauseMovie = pauseMovie;
          cthis.get(0).externalPlayMovie = playMovie;
          cthis.get(0).api_pauseMovie = pauseMovie;
          cthis.get(0).api_playMovie = playMovie;
          cthis.get(0).api_get_responsive_ratio = get_responsive_ratio;
        }
      }

      cthis.on('click', '.cover-image:not(.from-type-image), .div-full-image.from-type-audio', handleClickCoverImage);

      cthis.addClass('dzsvp-loaded');


      // console.info("type -", selfClass.dataType);

      // console.info('init_final -5',cthis)


      inter_videoReadyState = setInterval(check_videoReadyState, 50);

      if (is360) {

        // console.info("360!!!");


        $(selfClass._videoElement).on('click', function (e) {
          if (selfClass.initial_played == false) {
            playMovie();
            mouse_is_over();
          }
        })
        Dzsvg360.functionsInit(selfClass);
      }


      var _scrubbar = cthis.find('.scrubbar').eq(0);

      _scrubbar.on('touchstart', function (e) {
        scrubbar_moving = true;
      })

      if (o.ad_show_markers == 'on') {
        for (var i2 = 0; i2 < selfClass.ad_array.length; i2++) {
          // console.info(_scrubBg, (selfClass.ad_array[i2].time*100));
          //  _scrubBg.append('<span class="ad-marker" style="left: '+(selfClass.ad_array[i2].time*100)+'%"></span>');
          _scrubbar.find('.scrub').eq(0).before('<span class="reclam-marker" style="left: ' + (selfClass.ad_array[i2].time * 100) + '%"></span>');
          // _scrubbar.find('.scrub-buffer').append('<span class="ad-marker" style="left: '+(Number(selfClass.ad_array[i2].time)*_scrubBg)+'%"></span>');
        }
      }

      $(document).on('touchmove', function (e) {
        if (scrubbar_moving) {
          scrubbar_moving_x = e.originalEvent.touches[0].pageX;


          var aux3 = scrubbar_moving_x - _scrubbar.offset().left;

          if (aux3 < 0) {
            aux3 = 0;
          }
          if (aux3 > _scrubbar.width()) {
            aux3 = _scrubbar.width();
          }

          seek_to_perc(aux3 / _scrubbar.width());


          //console.info(aux3);


        }
      });

      $(document).on('touchend', function (e) {
        scrubbar_moving = false;
      })


      $(window).on('resize', handleResize);

      o.settings_trigger_resize = parseInt(o.settings_trigger_resize, 10);
      if (o.settings_trigger_resize > 0) {
        setInterval(function () {

          // console.info("HMM");
          handleResize(null, {
            'called_from': 'recheck_sizes'
          });
        }, o.settings_trigger_resize);
      }
      ;

      if (helpersDZSVG.is_touch_device()) {
        cthis.addClass('is-touch');
      }
    }


    function get_responsive_ratio(pargs) {


      var margs = {
        'reset_responsive_ratio': false
        , 'called_from': 'default'
      };
      // console.warn('get_responsive_ratio()',pargs, o.responsive_ratio);

      if (pargs) {
        margs = $.extend(margs, pargs);
      }

      if (margs.reset_responsive_ratio) {
        o.responsive_ratio = 'default';
      }


      if (o.responsive_ratio == 'detect') {

        // console.info('lets calculate responsive ratio', selfClass.dataType, video, selfClass._videoElement.selfClass.videoWidth,selfClass._videoElement.videoHeight);
        if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'selfHosted' || selfClass.dataType == 'dash') {
          if (selfClass._videoElement && selfClass._videoElement.videoHeight) {

            o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
          } else {
            o.responsive_ratio = 0.5625;
          }

          //console.info(o.responsive_ratio);
          if (selfClass._videoElement.addEventListener) {
            selfClass._videoElement.addEventListener('loadedmetadata', function () {
              o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
//                                console.info(o.responsive_ratio);
              handleResize();
            })
          }

          if (selfClass.dataType == 'dash') {
            selfClass.dash_inter_check_sizes = setInterval(function () {

              //console.info(selfClass.dataType, video, selfClass._videoElement.videoWidth,selfClass._videoElement.videoHeight);

              if (selfClass._videoElement && selfClass._videoElement.videoHeight) {
                if (selfClass._videoElement.videoWidth > 0) {

                  o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
                  handleResize();

                  clearInterval(selfClass.dash_inter_check_sizes);
                }
              }
            }, 1000);
          }

        }
        if (selfClass.dataType == 'audio') {

          if (cthis.find('.div-full-image').length) {

            var _cach = cthis.find('.div-full-image').eq(0);

            var aux = _cach.css('background-image');

            aux = aux.replace(/"/g, '');
            aux = aux.replace("url(", '');
            aux = aux.replace(")", '');

            var img = new Image();

            img.onload = function () {
              //console.info(this, this.naturalWidth, this.naturalHeight);

              o.responsive_ratio = this.naturalHeight / this.naturalWidth;
//                                console.info(o.responsive_ratio);
              handleResize();

            };


            img.src = aux;

            //console.info(aux);
            //
            //console.info(cthis.find('.div-full-image').eq(0))
          }


        }
        if (selfClass.dataType == 'youtube') {

          o.responsive_ratio = 0.5625;
        }
        if (selfClass.dataType == 'vimeo') {

          o.responsive_ratio = 0.5625;
        }
        if (selfClass.dataType == 'inline') {

          o.responsive_ratio = 0.5625;
        }

      }
      o.responsive_ratio = Number(o.responsive_ratio);

      if (cthis.hasClass('vp-con-laptop')) {
        o.responsive_ratio = '';
      }
    }


    function destroy_listeners() {

      console.warn('destroy_listeners', cthis);
      cthis.unbind('mouseout', handleMouseout);
      cthis.unbind('mouseover', handleMouseover);
      cthis.find('.controls').eq(0).unbind('mouseover', handle_mouse);
      cthis.find('.controls').eq(0).unbind('mouseout', handle_mouse);
      cthis.unbind('mousemove', handle_mousemove);
      cthis.unbind('keydown', handleKeyPress);
      fScreenControls.off('click', fullscreenToggle)
      scrubbar.unbind('click', handleScrub);
      scrubbar.unbind('mousedown', handle_mouse);
      scrubbar.unbind('mousemove', handleScrubMouse);
      scrubbar.unbind('mouseout', handleScrubMouse);
      cthis.unbind('mouseleave', handleScrubMouse);
      cthis.off('click');
      cthis.find('.mutecontrols-con').unbind('click', click_mutecontrols);
      document.removeEventListener('fullscreenchange', handleFullscreenChange, false);


      if (o.gallery_object == null) {
        $(window).off('resize', handleResize);
      }

      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio') {

        selfClass._videoElement.removeEventListener('ended', handleVideoEnd, false);
      }
    }

    function check_if_hd_available() {


      if (yt_qualArray.length > 0) {
        return false;
      }


      yt_qualCurr = selfClass._videoElement.getPlaybackQuality();

      yt_qualArray = selfClass._videoElement.getAvailableQualityLevels();

      // console.info('yt_qualCurr -7 ',yt_qualCurr, yt_qualArray);

      if ($.inArray('hd720', yt_qualArray) > -1) {
        hasHD = true;
      }

      if (yt_qualArray.length > 1) {
        cthis.addClass('has-multiple-quality-levels');
      }


      if (selfClass._controlsDiv) {
        var _qualitySelector = cthis.find('.quality-selector');
        if (_qualitySelector.length == 0) {

          if (hasHD == true) {

            if (selfClass._controlsDiv.children('.hdbutton-con').length == 0) {
              if (o.settings_suggestedQuality != 'default') {
                if (yt_qualCurr != o.settings_suggestedQuality) {
                  selfClass._videoElement.setPlaybackQuality(o.settings_suggestedQuality);
                }
              }


              //console.log(o.design_skin);
              if (o.design_skin == 'skin_pro') {
                selfClass._controlsDiv.find('.timetext').after('<div class="hdbutton-con"><div class="hdbutton-normal">HD</div></div>');

              } else {

                selfClass._controlsDiv.append('<div class="hdbutton-con"><div class="hdbutton-normal">HD</div></div>');
              }

              _btnhd = selfClass._controlsDiv.children('.hdbutton-con');
              if (yt_qualCurr == 'hd720' || yt_qualCurr == 'hd1080') {
                _btnhd.addClass('active');
              }
              _btnhd.bind('click', click_hd);


              resizePlayer(selfClass.videoWidth, selfClass.videoHeight);
            }

          }
        } else {

          // no-quality selector

          if (_qualitySelector.find('.dzsvg-tooltip').length) {

            var aux = _qualitySelector.find('.dzsvg-tooltip').html();
            var aux_opts = '';
            // console.info('yt_qualArray -> ', yt_qualArray);
            for (var i2 in yt_qualArray) {
              aux_opts += '<div class="quality-option';
              if (yt_qualCurr == yt_qualArray[i2]) {
                aux_opts += ' active';
              }
              aux_opts += '" data-val="' + yt_qualArray[i2] + '">' + yt_qualArray[i2] + '</div>';
            }
            aux = aux.replace('{{quality-options}}', aux_opts);
            _qualitySelector.find('.dzsvg-tooltip').html(aux);
          }

        }

      }

    }

    function handle_mouse(e) {
//                console.info(e.pageX, e.pageY);
      var _t = $(this);


      if (e.type == 'mouseover') {

        if (_t.hasClass('controls')) {

          controls_are_hovered = true;
        }
      }
      if (e.type == 'mouseout') {

        if (_t.hasClass('controls')) {

          controls_are_hovered = false;
        }
      }

      if (e.type == 'mousedown') {

        if (_t.hasClass('volumecontrols')) {

          volume_mouse_down = true;
        }
        if (_t.hasClass('scrubbar')) {


          clearTimeout(inter_mousedownscrubbing);
          inter_mousedownscrubbing = setTimeout(enable_mousedown_scrubbing, 100);

        }
      }
      if (e.type == 'click') {

        player_user_had_first_interaction();

        if (_t.hasClass('mute-indicator')) {
          // console.log('mute-indicator -5 ','ceva');
          selfClass.volumeClass.player_volumeUnmute();
        }
        if (_t.hasClass('quality-option')) {


          if (_t.hasClass('active')) {
            return false;
          }


          selfClass.queue_goto_perc = time_curr / totalDuration;
          if (selfClass.dataType == 'youtube') {

            // console.info("_t.attr('data-val') - ",_t.attr('data-val'));
            selfClass._videoElement.setPlaybackQuality(_t.attr('data-val'));


            // console.warn('queue_goto_perc - ',queue_goto_perc);

            selfClass._videoElement.stopVideo();
            selfClass._videoElement.setPlaybackQuality(_t.attr('data-val'));
            selfClass._videoElement.playVideo();


            setTimeout(function () {

              yt_qualCurr = selfClass._videoElement.getPlaybackQuality();

              console.info('yt_qualCurr - ', yt_qualCurr)


            }, 2000)
          }


          // console.info('selfClass.dataType - ',selfClass.dataType);
          if (selfClass.dataType == 'selfHosted') {


            var newsource = selfClass.dataSrc;

            // console.info(video);

            var _c = $(selfClass._videoElement).eq(0);

            cthis.find('.the-video').addClass('transitioning-out');

            _c.after(_c.clone());

            var _c2 = _c.next();

            _c2.removeClass('transitioning-out transitioning-in');
            _c2.addClass('preparing-transitioning-in js-transitioning-in');
            _c2.html('<source src="' + newsource + '">')


            var aux_wasPlaying = selfClass.wasPlaying;
            _c2.on('loadeddata', function () {
              console.warn("LOADED DATA");

              _c2.off('loadeddata');
              selfClass._videoElement = _c2.get(0);

              if (selfClass.queue_goto_perc) {
                seek_to_perc(selfClass.queue_goto_perc);
                selfClass.queue_goto_perc = '';
              }


              if (is360) {
                Dzsvg360.afterQualityChange(selfClass);
              }


              setTimeout(function () {

                pauseMovie();
                if (cthis.find('.transitioning-out').get(0).pause) {
                  cthis.find('.transitioning-out').get(0).pause();
                }
                cthis.find('.transitioning-out').remove();

                cthis.find('.the-video.js-transitioning-in').addClass('transitioning-in');


                if (aux_wasPlaying) {
                  playMovie();
                }
              }, 500)

            })

            setTimeout(function () {

            }, 100);
          }


          _t.parent().children().removeClass('active');
          _t.addClass('active');
        }
      }
      if (e.type == 'mouseup') {

        clearTimeout(inter_mousedownscrubbing);

        //console.info('window mouseup');
        volume_mouse_down = false;
        scrub_mouse_down = false;
      }
    }

    function enable_mousedown_scrubbing() {

      scrub_mouse_down = true;
    }

    function handle_mousemove(e) {
      //console.info(e.pageX, e.pageY);
      // console.info('mousemove', is_fullscreen, o.settings_disable_mouse_out, o.settings_disable_mouse_out_for_fullscreen, o.settings_mouse_out_delay_for_fullscreen);
      cthis.removeClass('mouse-is-out');
      mouseover = true;

      if (volume_mouse_down) {
        handleMouseOnVolume(e);
      }
      if (scrub_mouse_down) {


        var argperc = (e.pageX - (scrubbar.offset().left)) / (scrubbar.children().eq(0).width());
        seek_to_perc(argperc);
      }

      if (is_fullscreen) {


        if (o.settings_disable_mouse_out != 'on' && o.settings_disable_mouse_out_for_fullscreen != 'on') {
          clearTimeout(inter_removeFsControls);
          inter_removeFsControls = setTimeout(controls_mouse_is_out, o.settings_mouse_out_delay_for_fullscreen);
        }

        if (e.pageX > ww - 10) {
          controls_are_hovered = false;
        }
      }
    }

    function controls_mouse_is_out() {

      // console.info('controls_mouse_is_out', paused, controls_are_hovered, cthis);
      if (selfClass.paused == false && (controls_are_hovered == false || helpersDZSVG.is_android())) {

        cthis.removeClass('mouse-is-over');
        cthis.addClass('mouse-is-out');
      }
      mouseover = false;
    }

    function handleVideoEvent(e) {

      // console.info('handleVideoEvent', e, e.type);

      if (e.type == 'play') {

        played = true;

        if (helpersDZSVG.is_ios() || helpersDZSVG.is_android()) {
          cthis.find('.controls').eq(0).css('pointer-events', 'auto');
        }
        setup_skipad();
      }
    }


    function setup_subtitle() {
      var subtitle_input = '';
      if (cthis.children('.subtitles-con-input').length > 0) {
        subtitle_input = cthis.children('.subtitles-con-input').eq(0).html();
        // console.info('subtitle_input - ', subtitle_input);
        parse_subtitle(subtitle_input);
      } else {
        if (o.settings_subtitle_file != '') {
          $.ajax({
            url: o.settings_subtitle_file
            , success: function (response) {
//                                console.info(response);
              subtitle_input = response;
              parse_subtitle(subtitle_input);
            }
          });
        }
      }
    }

    function parse_subtitle(arg) {
      // var regex_subtitle = /([0-9]+(?:\.[0-9]*)?)[\s\S]*?((.*)--[>|\&gt;](.*))[\n|\r]([\s\S]*?)[\n|\r]/g;
      var regex_subtitle = /([0-9](?:[0-9]|:|,| )*)[–|-]*(?:(?:\&gt;)|>) *([0-9](?:[0-9]|:|,| )*)[\n|\r]([\s\S]*?)[\n|\r]/g;
      var arr_subtitle = [];
      cthis.append('<div class="subtitles-con"></div>')


      console.log('regex_subtitle.exec(arg)-  ', regex_subtitle.exec(arg), arg, regex_subtitle);
      while (arr_subtitle = regex_subtitle.exec(arg)) {
        console.info('arr_subtitle - ', arr_subtitle);

        var starttime = '';
        if (arr_subtitle[1]) {
          starttime = format_to_seconds(arr_subtitle[1]);
        }
        var endtime = '';
        if (arr_subtitle[2]) {
          arr_subtitle[2] = String(arr_subtitle[2]).replace('gt;', '');
          endtime = format_to_seconds(arr_subtitle[2]);
        }

        var cnt = '';
        if (arr_subtitle[3]) {
          cnt = arr_subtitle[3];
        }

        console.log('startTime - ', starttime, 'endtime - ', endtime, 'cnt - ', cnt);

        cthis.children('.subtitles-con').append('<div class="dzstag subtitle-tag" data-starttime="' + starttime + '" data-endtime="' + endtime + '">' + cnt + '</div>');
      }
      arrTags = cthis.find('.dzstag');

    }

    function format_to_seconds(arg) {
//                console.info(arg);
      var argsplit = String(arg).split(':');
      argsplit.reverse();
      var secs = 0;
//                console.info(argsplit);
      if (argsplit[0]) {
        argsplit[0] = String(argsplit[0]).replace(',', '.');
        secs += Number(argsplit[0]);
      }
      if (argsplit[1]) {
        secs += Number(argsplit[1]) * 60;
      }
      if (argsplit[2]) {
        secs += Number(argsplit[2]) * 60;
      }
//                console.info(secs);

      return secs;
    }


    function handleClickCoverImage(e) {
      //console.log(cthis.find('.cover-image'));


      if (e) {
        player_user_had_first_interaction();
      }

      if (selfClass.dataType != 'image') {
        if (selfClass.wasPlaying == false) {
          playMovie({
            'called_from': 'click coverImage'
          });
        } else {
          pauseMovie({
            'called_from': 'click coverImage'
          });
        }
      }
    }

    function player_user_had_first_interaction() {

      if (selfClass.cthis.data('userHadFirstInteraction')) {
        return false;
      }

      // console.log('%c player_user_had_first_interaction() - ', ConstantsDzsvg.DEBUG_STYLING);
      selfClass.isHadFirstInteraction = true;
      setTimeout(() => {
        // -- eliminate any concurrent events
        selfClass.cthis.addClass('user-had-first-interaction');

        if (selfClass.parentGallery) {
          selfClass.parentGallery.addClass('user-had-first-interaction');
        }
      }, 100);

      // -- unmute
      selfClass.volumeClass.player_volumeUnmute();
      selfClass.cthis.removeClass('autoplay-fallback--started-muted');


      selfClass.cthis.removeClass('is-muted');
      selfClass.cthis.data('userHadFirstInteraction', 'on');
      selfClass.is_muted_for_autoplay = false;
    }

    function click_videoOverlay(e) {
      // -- check if user event

      const wasMutedForAutoplayBeforeClick = selfClass.is_muted_for_autoplay;
      if (e) {
        player_user_had_first_interaction();
      }


      if (is360) {
        Dzsvg360.enableControls();
      }

      // console.log('click_videoOverlay() - ', 'wasMutedForAutoplayBeforeClick - ', wasMutedForAutoplayBeforeClick);
      if (selfClass.isAd) {
        if (!selfClass.cthis.hasClass('user-had-first-interaction')) {
          // -- no previous interaction
          handleClickPlayPause();
          if (cthis.hasClass('mobile-pretime-ad') && cthis.hasClass('first-played') == false) {
            return false;
          }
        } else {
          // -- previous interaction, now open link
          if (selfClass.ad_link) {
            window.open(selfClass.ad_link);
            selfClass.ad_link = null;
            return false;
          } else {
            return false;
          }
        }
        // console.log('selfClass.cthis.hasClass(\'first-played\') - ', selfClass.cthis.hasClass('first-played'));

        if (selfClass._videoElement && selfClass._videoElement.paused) {
          playMovie({
            'called_from': 'click_videoOverlay'
          });
        }
        if (e) {
          e.stopPropagation();
        }
      } else {

        // -- is not an AD

        if (selfClass.wasPlaying && wasMutedForAutoplayBeforeClick) {
          // -- just unmute
          selfClass.is_muted_for_autoplay = false;
        } else {
          if (selfClass.wasPlaying === false) {
            playMovie({
              'called_from': '_click_videoOverlay()'
            });
          } else {
            pauseMovie({
              'called_from': '_click_videoOverlay()'
            });
          }
        }
      }
    }

    function click_hd() {
      var _t = $(this);
      //console.log(_t);
      if (_t.hasClass('active')) {
        _t.removeClass('active');
        if ($.inArray('large', yt_qualArray) > -1) {
          selfClass._videoElement.setPlaybackQuality('large');
        } else {
          if ($.inArray('medium', yt_qualArray) > -1) {
            selfClass._videoElement.setPlaybackQuality('medium');
          } else {
            if ($.inArray('small', yt_qualArray) > -1) {
              selfClass._videoElement.setPlaybackQuality('small');
            }
          }
        }

      } else {
        _t.addClass('active');
        if ($.inArray('hd1080', yt_qualArray) > -1) {
          selfClass._videoElement.setPlaybackQuality('hd1080');
        } else {

          if ($.inArray('hd720', yt_qualArray) > -1) {
            selfClass._videoElement.setPlaybackQuality('hd720');
          }
        }
      }
    }

    function mouse_is_over() {

      if (is360) {
        Dzsvg360.enableControls();
      }
      clearTimeout(inter_removeFsControls);
      cthis.removeClass('mouse-is-out');
      cthis.addClass('mouse-is-over');
    }

    function handleMouseover(e) {

      // console.info('mouseover', e.currentTarget);

      if ($(e.currentTarget).hasClass('vplayer')) {
        if (o.settings_disable_mouse_out != 'on') {
          if (fullscreen_just_pressed == false) {
            mouse_is_over();
          }
        }
      }
      if ($(e.currentTarget).hasClass('fullscreen-button')) {

        helpersDZSVG.player_controls_drawFullscreenBarsOnCanvas(selfClass, _controls_fs_canvas, o.controls_fscanvas_hover_bg);
      }


    }

    function handleMouseout(e) {

      Dzsvg360.enableControls();
      // console.info(' - mouseout - ');

      if (selfClass.dataType == 'youtube' && is_fullscreen) {
        fullscreen_just_pressed = true;

        setTimeout(function () {
          fullscreen_just_pressed = false;
        }, 500)
      }
      if ($(e.currentTarget).hasClass('vplayer')) {


        // console.info('settings_disable_mouse_out - ',o.settings_disable_mouse_out);
        if (o.settings_disable_mouse_out != 'on') {


          clearTimeout(inter_removeFsControls);

          // console.info('delay - ' ,o.settings_mouse_out_delay_for_fullscreen);
          inter_removeFsControls = setTimeout(controls_mouse_is_out, o.settings_mouse_out_delay);
        }
      }
      if ($(e.currentTarget).hasClass('fullscreen-button')) {
        helpersDZSVG.player_controls_drawFullscreenBarsOnCanvas(selfClass, _controls_fs_canvas, o.controls_fscanvas_bg);
      }

    }

    function handleScrubMouse(e) {
      //console.log(e.type, e);
      if (!scrubbar) {
        return false;
      }
      var _t = scrubbar;


      if (e.type == 'mousemove') {
        //console.log(e, e.pageX, jQuery(this).offset().left)
        var mouseX = (e.pageX - $(this).offset().left) / currScale;
        //console.log(_t,_t.children('.scrubBox'));
        var aux = (mouseX / scrubbg_width) * totalDuration;
        _t.children('.scrubBox').html(helpersDZS.formatTime(aux));
        _t.children('.scrubBox').css({'visibility': 'visible', 'left': (mouseX - 16)});
      }
      if (e.type == 'mouseout') {
        _t.children('.scrubBox').css({'visibility': 'hidden'});

      }
      if (e.type == 'mouseleave') {
        _t.children('.scrubBox').css({'visibility': 'hidden'});
      }
      //console.log(mouseX);
    }


    function handleScrub(e) {
      /*
                 if (selfClass.wasPlaying == false){
                 pauseMovie();
                 }else{
                 //console.log(selfClass.dataType);
                 playMovie();
                 }
                 */
      //console.log(selfClass.dataType);
      //return;
      player_user_had_first_interaction();

      var argperc = (e.pageX - (scrubbar.offset().left)) / (scrubbar.children().eq(0).width());
      seek_to_perc(argperc);
    }

    function seek_to_perc(argperc) {
      //console.info('seek_to_perc()',argperc)


      var argperccheckads = playerAdFunctions.checkForAdAlongTheWay(selfClass, argperc);

      if (argperccheckads) {
        argperc = argperccheckads;
      }
      // console.info(argperc);

      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
        totalDuration = selfClass._videoElement.duration;


        if (isNaN(totalDuration)) {
          return false;
        }
        // console.info(totalDuration, argperc)
        selfClass._videoElement.currentTime = (argperc) * totalDuration;
      }
      if (selfClass.dataType == 'youtube') {
        //console.log(selfClass._videoElement.getDuration());


        if (selfClass._videoElement && selfClass._videoElement.getDuration) {

          totalDuration = selfClass._videoElement.getDuration();
        } else {
          console.info('vplayer warning, youtube type - youtube api not ready .. ? ');
          totalDuration = 0;
        }
        //console.info(time_curr, totalDuration);

        // -- no need for seek to perct if video has not started.
        if (isNaN(totalDuration) || (time_curr == 0 && argperc == 0)) {
          return false;
        }

        selfClass._videoElement.seekTo(argperc * totalDuration);


        // console.info('selfClass.wasPlaying - ',selfClass.wasPlaying);
        if (selfClass.wasPlaying == false) {
          pauseMovie({
            'called_from': '_seek_to_perc()'
          });
        }
      }


      if (selfClass.dataType == 'vimeo') {
        //if (/Opera/.test(navigator.userAgent)) {
        //    return;
        //}

        //console.info(selfClass.initial_played);
        if (argperc == 0 && selfClass.initial_played) {

          vimeo_data = {
            "method": "seekTo"
            , "value": "0"
          };

          if (selfClass.vimeo_url) {
            try {
              selfClass._videoElement.contentWindow.postMessage(JSON.stringify(vimeo_data), selfClass.vimeo_url);

              selfClass.wasPlaying = false;
              selfClass.paused = true;
            } catch (err) {
              if (window.console) {
                console.log(err);
              }
            }
          }
        } else {

          if (o.vimeo_is_chromeless == 'on') {
            vimeo_data = {
              "method": "seekTo"
              , "value": (argperc) * totalDuration
            };

            if (selfClass.vimeo_url) {
              try {
                selfClass._videoElement.contentWindow.postMessage(JSON.stringify(vimeo_data), selfClass.vimeo_url);

              } catch (err) {
                if (window.console) {
                  console.log(err);
                }
              }
            }
          }

        }
      }

    }

    function handleEnterFrame(pargs) {
      // -- enterFrame function

      var margs = {
        skin_play_check: false
      }

      if (pargs) {
        margs = $.extend(margs, pargs);
      }
      // console.warn('handleEnterFrame');

      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
        totalDuration = selfClass._videoElement.duration;
        time_curr = selfClass._videoElement.currentTime;

        //console.log(cthis, selfClass._videoElement.buffered.end(0), selfClass.bufferedWidthOffset);

        if (scrubbar && selfClass._videoElement && selfClass._videoElement.buffered && selfClass._videoElement.readyState > 1) {
          bufferedLength = 0;
          try {

            bufferedLength = (selfClass._videoElement.buffered.end(0) / selfClass._videoElement.duration) * (scrubbar.children().eq(0).width() + selfClass.bufferedWidthOffset);
          } catch (err) {
            console.log(err);
          }
        }


      }
      if (selfClass.dataType == 'youtube') {
//                    console.log(selfClass._videoElement.getVideoLoadedFraction())
        if (selfClass._videoElement.getVideoLoadedFraction == undefined || selfClass._videoElement.getVideoLoadedFraction == 0) {
          return false;
        }
        if (selfClass._videoElement.getDuration != undefined) {
          totalDuration = selfClass._videoElement.getDuration();
          time_curr = selfClass._videoElement.getCurrentTime();
        }
        if (_scrubBg) {

          bufferedLength = (selfClass._videoElement.getVideoLoadedFraction()) * (_scrubBg.width() + selfClass.bufferedWidthOffset);
        }

//                    console.info(selfClass._videoElement.getVideoLoadedFraction(), scrubbar, _scrubBg,  (_scrubBg.width() + selfClass.bufferedWidthOffset), bufferedLength);
        aux = 0;
        if (scrubbar) {

          scrubbar.children('.scrub-buffer').css('left', aux);
        }


      }
      aux = ((time_curr / totalDuration) * (scrubbg_width));

      // console.info(time_curr, totalDuration, scrubbg_width);
      if (aux > scrubbg_width) {
        aux = scrubbg_width;
      }
      aux = parseInt(aux, 10);
      // scrubbar.children('.scrub').width(aux);


      if (o.vimeo_is_chromeless == 'on') {
        if (scrubbar) {
          scrubbar.children('.scrub').css({
            'width': aux
          }, {});
        }
      } else {

        if (scrubbar) {
          scrubbar.children('.scrub').animate({
            'width': aux
          }, {
            queue: false
            , duration: ConstantsDzsvg.ANIMATIONS_DURATION
            , easing: "linear"

          });
        }
      }


      if (bufferedLength > -1) {
        if (bufferedLength > scrubbg_width + selfClass.bufferedWidthOffset) {
          bufferedLength = scrubbg_width + selfClass.bufferedWidthOffset;
        }
        if (scrubbar) {
          scrubbar.children('.scrub-buffer').width(bufferedLength)
        }
      }
      if (_timetext && _timetext.css('display') != 'none' && (selfClass.wasPlaying == true || margs.skin_play_check == true) || (selfClass.dataType == 'vimeo' && o.vimeo_is_chromeless == 'on')) {

        var aux35 = helpersDZS.formatTime(totalDuration);


        if (o.design_skin != 'skin_reborn') {

          aux35 = ' / ' + aux35;
        }

        //console.info(o.design_skin);


        _timetext.children(".curr-timetext").html(helpersDZS.formatTime(time_curr));
        _timetext.children(".total-timetext").html(aux35);

      }
      if (o.design_enableProgScrubBox == 'on') {

        if (scrubbar) {
          scrubbar.children('.scrubBox-prog').html(helpersDZS.formatTime(time_curr));
          // scrubbar.children('.scrubBox-prog').css('left', aux - 16);

          scrubbar.children('.scrubBox-prog').animate({
            'left': aux - 16
          }, {
            queue: false
            , duration: ConstantsDzsvg.ANIMATIONS_DURATION
            , easing: "linear"

          })
        }
      }
      if (o.playfrom == 'last') {
        if (typeof Storage != 'undefined') {
          localStorage['dzsvp_' + the_player_id + '_lastpos'] = time_curr;
          // console.warn('dzsvp_'+the_player_id+'_lastpos');
        }
      }

    }


    function click_mutecontrols(e) {
      var _t = $(this);
      _t.toggleClass('active');

      if (_t.hasClass('active')) {
        selfClass.volumeLast = selfClass.volumeClass.volume_getVolume();
        player_volumeMute();
      } else {

        volume_setupVolumePerc(selfClass.volumeLast, {'called_from': 'volume_unmute'});
      }
    }


    function player_volumeMute() {

      videoElementFunctions.video_mute(selfClass);
    }


    function handleMouseOnVolume(e) {


      // -- from user action


      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'youtube') {
        // -- we can remove muted on user action
        player_user_had_first_interaction();
      }

      const _volumeReferenceTarget = selfClass._volumeControls.eq(1).length ? selfClass._volumeControls.eq(1) : selfClass._volumeControls.eq(0);
      const mousePositionRelativeToVolumeControls = (e.pageX - (_volumeReferenceTarget.offset().left));

      selfClass._volumeControls = cthis.find('.volumecontrols').children();
      if (mousePositionRelativeToVolumeControls >= 0) {

        // console.info("CLICKED INISDE VOLUME");

        aux = (e.pageX - (_volumeReferenceTarget.offset().left)) / currScale;

        //selfClass._volumeControls.eq(2).height(24)
        selfClass._volumeControls.eq(2).css('visibility', 'visible')
        selfClass._volumeControls.eq(3).css('visibility', 'hidden')

        volume_setupVolumePerc(aux / _volumeReferenceTarget.width(), {'called_from': 'handleMouseOnVolume'});
      } else {

        // -- set volume to 0  when x < 0

        // console.log('SET VOLUME TO 0 when x < 0 ')
        if (selfClass._volumeControls.eq(3).css('visibility') == 'hidden') {
          selfClass.volumeLast = selfClass.volumeClass.volume_getVolume();
          volume_setupVolumePerc(0)


          if (selfClass.dataType == 'vimeo') {
            vimeo_data = {
              "method": "setVolume"
              , "value": "0"
            };

            if (selfClass.vimeo_url) {
              helpersDZSVG.vimeo_do_command(selfClass, vimeo_data, selfClass.vimeo_url);
            }
          }
          selfClass._volumeControls.eq(3).css('visibility', 'visible')
          selfClass._volumeControls.eq(2).css('visibility', 'hidden')
        } else {
          //console.log(selfClass.volumeLast);

          // console.info('selfClass.dataType');
          volume_setupVolumePerc(selfClass.volumeLast)

          // console.error('selfClass.volumeLast - ',selfClass.volumeLast);

          selfClass._volumeControls.eq(3).css('visibility', 'hidden')
          selfClass._volumeControls.eq(2).css('visibility', 'visible')
        }
      }

    }

    /**
     *
     * @param argumentVolumePerc
     * @param pargs
     */
    function volume_setupVolumePerc(argumentVolumePerc, pargs) {

      // -- @arg is ratio 0 - 1
      var margs = {
        'called_from': 'default'
      }
      if (pargs) {
        margs = $.extend(margs, pargs);
      }
      // console.log('volume_setupVolumePerc() ' , margs);
      if (argumentVolumePerc > 1) {
        argumentVolumePerc = 1;
      }
      selfClass.volumeClass.set_volume(argumentVolumePerc);
    }


    function handleVideoEnd() {
      // console.info('[videoplayer] handleVideoEnd() - ', selfClass.cthis, is_fullscreen, selfClass.dataType, window.fullscreen);

      // -- function on video end

      if (selfClass.dataType == 'vimeo') {
        if (o.end_exit_fullscreen == 'on') {
          if (helpersDZSVG.fullscreen_status() == 1) {
            helpersDZSVG.exitFullscreen();
          }
        } else {
          // helpersDZSVG.requestFullscreen()
        }
      }


      if (helpersDZSVG.fullscreen_status() == 1) {
        // console.log('o.end_exit_fullscreen - ', o.end_exit_fullscreen);
        if (o.end_exit_fullscreen == 'on') {
          fullscreenToggle(null, {
            'called_from': 'handleVideoEnd .. forced o.end_exit_fullscreen',
            'force_exit_fullscreen': true,
          }); // -- we exit fullscreen if video has ended on fullscreen
        }
        setTimeout(function () {
          handleResize();
        }, 100);
      }


      // console.info('selfClass.dataType - ',selfClass.dataType);
      selfClass.cthis.addClass('is-video-end-screen');
      // console.log('selfClass.dataType -' , selfClass.dataType);
      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {

        // console.info("loop - ", selfClass.isLoop, video);
        if (selfClass.isLoop) {
          // console.info("YES");
          seek_to_perc(0);
          playMovie({
            'called_from': 'play_from_loop'
          });
          selfClass.cthis.removeClass('is-video-end-screen');
          return false;
        }
        if (selfClass._videoElement) {
          if (o.settings_video_end_reset_time == 'on') {
            selfClass._videoElement.currentTime = 0;
            if (selfClass.isLoop) {
              pauseMovie({
                'called_from': 'end_video()'
              });
              cthis.find('.cover-image').fadeIn('slow');
            } else {

            }


          }
        }
      }
      if (selfClass.dataType == 'youtube') {
        // console.log('selfClass.isLoop - ', selfClass.isLoop);
        if (selfClass.isLoop) {
          // console.info("YES");
          seek_to_perc(0);
          setTimeout(function () {

            playMovie({
              'called_from': 'play_from_loop'
            });
          }, 1000);

          selfClass.suspendStateForLoop = true;
          setTimeout(function () {
            selfClass.suspendStateForLoop = false;
          }, 1500);
          selfClass.cthis.removeClass('is-video-end-screen');
          return false;
        }
        //console.log(selfClass._videoElement.getDuration())
        if (selfClass._videoElement) {
          if (selfClass._videoElement && selfClass._videoElement.pauseVideo) {
            selfClass.wasPlaying = false;
            if (o.settings_video_end_reset_time == 'on') {

              // -- youtube already shows cover photo and replay button - maybe no need

              //seek_to_perc(0);
              //
              //selfClass._videoElement.pauseVideo();
            }
          }
        }
      }


      // console.log("PASS EVENT TO GALLERY", cthis, o.gallery_object);

      // console.log('pass event to parent_player - ', o.parent_player)

      if (o.gallery_object) {
        if (typeof (o.gallery_object.get(0)) != 'undefined') {
          o.gallery_object.get(0).videoEnd();
        }

      }
      if (o.parent_player) {
        if (o.parent_player.get(0)) {
          o.parent_player.get(0).api_ad_end();
        }

      }

      if (action_video_end) {
        action_video_end(cthis);
      }

    }

    function handleResize(e, pargs) {
      // console.log('vplayer triggered resize',e,pargs);


      var margs = {
        'force_resize_gallery': false
        , 'called_from': 'default'
      };

      if (pargs) {
        margs = $.extend(margs, pargs);
      }


      selfClass.videoWidth = cthis.width();
      selfClass.videoHeight = cthis.height();


      if (margs.called_from == 'recheck_sizes') {

        // console.info('recheck_sizes player', Math.abs(last_selfClass.videoHeight-selfClass.videoHeight), Math.abs(last_videoWidth-videoWidth));
        if (Math.abs(last_videoHeight - selfClass.videoHeight) < 4 && Math.abs(last_videoWidth - selfClass.videoWidth) < 4) {


          return false;
        }

      }

      last_videoWidth = selfClass.videoWidth;
      last_videoHeight = selfClass.videoHeight;


      //console.info(cthis, o.responsive_ratio, isNaN(o.responsive_ratio), selfClass.videoWidth, videoHeight);


      // console.info('responsive_ratio', o.responsive_ratio, auxh);

      // console.info('o.responsive_ratio', o.responsive_ratio);
      if (isNaN(o.responsive_ratio) === true) {

        // -- then we have no responsive ratio
        // o.responsive_ratio = 0.5675;
      }
      if (isNaN(o.responsive_ratio) === false && o.responsive_ratio > 0) {

        var auxh = o.responsive_ratio * selfClass.videoWidth;


        if ('o.gallery_object -', o.gallery_object && ((cthis.hasClass('currItem') && !selfClass.isAd) || margs.force_resize_gallery)) {
          //console.warn("RESIZE IT!",cthis, auxh , o.responsive_ratio, selfClass.videoWidth, selfClass.videoHeight);
          if (o.gallery_object.get(0) && o.gallery_object.get(0).api_responsive_ratio_resize_h) {
            o.gallery_object.addClass('responsive-ratio-smooth');
            o.gallery_object.get(0).api_responsive_ratio_resize_h(auxh, {
              caller: cthis
            });
          }
        } else {
          //console.info('single player', o.responsive_ratio);

          //console.warn(o);

          if (!selfClass.isAd) {

            cthis.height(o.responsive_ratio * cthis.width());
          }
        }
      }
      if (cthis.hasClass('vp-con-laptop')) {

        if (o.gallery_object.get(0) && o.gallery_object.get(0).api_responsive_ratio_resize_h) {
          o.gallery_object.addClass('responsive-ratio-smooth');
          o.gallery_object.get(0).api_responsive_ratio_resize_h(selfClass.videoWidth * 0.5466, {
            caller: cthis
          });
        }
      }


      if (selfClass.videoWidth < 600) {
        cthis.addClass('under-600');

        if (o.design_skin == 'skin_aurora') {
          o.design_scrubbarWidth = selfClass.original_scrubwidth - 10;
        }


        if (selfClass.videoWidth < 421) {
          cthis.addClass('under-420');

          if (o.design_skin == 'skin_aurora') {
            o.design_scrubbarWidth = selfClass.original_scrubwidth - 10;
          }
        } else {
          cthis.removeClass('under-420');
          if (o.design_skin == 'skin_aurora') {
            o.design_scrubbarWidth = selfClass.original_scrubwidth;
          }
        }
      } else {
        cthis.removeClass('under-600');
        if (o.design_skin == 'skin_aurora') {
          o.design_scrubbarWidth = selfClass.original_scrubwidth;
        }
      }


      if (helpersDZSVG.fullscreen_status() === 1) {
        ww = $(window).width();
        wh = window.innerHeight;
        resizePlayer(ww, wh);


        cthis.css('transform', '');
        currScale = 1;
      } else {

        //console.info(cthis, selfClass.videoWidth,videoHeight);
        resizePlayer(selfClass.videoWidth, selfClass.videoHeight);
      }

    }

    function handleKeyPress(e) {
      //-check if space is pressed for pause

      // console.info('keypress player - ',e, e.which, e.charCode,e.keyCode);

      if (mouseover) {
        if (e.charCode == 27 || e.keyCode == 27) {
          setTimeout(function () {
            // console.info("ESC KEY from player");
            handleResize(null, {
              'called_from': 'esc_key'
            });
          }, 300);
        }
        if (e.charCode == 32 || e.keyCode == 32) {
          handleClickPlayPause();


          // console.info('mouseover - ',mouseover);
          e.stopPropagation();
          e.preventDefault();
          return false;
        }
      }
    }

    function vimeo_windowMessage(e) {
      // -- we receive iframe messages from vimeo here
      var data, method;
      //console.log(e);

      if (e.origin != 'https://player.vimeo.com' && e.origin != 'http://player.vimeo.com') {
        return;
      }
      if (!selfClass._videoElement) {
        console.log('[dzsvg][log] video element does not exist for a reason ..', selfClass, e);
        return false;
      }
      selfClass.vimeo_url = '';
      // console.info('vimeo_windowMessage() received event from vimeo - ', e);

      if ($(selfClass._videoElement).attr('src')) {
        selfClass.vimeo_url = $(selfClass._videoElement).attr('src').split('?')[0];
      }
      vimeo_is_ready = true;

      if (String(selfClass.vimeo_url).indexOf('http') != 0) {
        selfClass.vimeo_url = 'https:' + selfClass.vimeo_url;
      }

      //console.info('selfClass.vimeo_url',selfClass.vimeo_url);
      try {
        data = JSON.parse(e.data);
        method = data.event || data.method;

        // console.warn(data);

        if (data.data.duration) {
          time_curr = data.data.seconds;
          totalDuration = data.data.duration;
        }
      } catch (err) {
        //fail silently... like a ninja!
        // console.log('json parse error',err,e)
      }

      if (e && typeof (e.data) == 'object') {
        data = e.data;
      }


      //if(cthis.attr)
      if (data && data.player_id && selfClass.dataSrc != data.player_id.substr(11)) {
        return;
      }

      if (data != undefined) {
        if (data.event == 'pause') {
          pauseMovie_visual();
        }
        if (data.event == 'ready') {
          //console.log(cthis);
          if (selfClass.autoplayVideo == 'on') {
            // -- we don't force play Movie because we already set autoplay to 1 on the iframe
            //playMovie();
          }
          vimeo_data = {
            "method": "addEventListener",
            "value": "finish"
          };
          helpersDZSVG.vimeo_do_command(selfClass, vimeo_data, selfClass.vimeo_url);

          vimeo_data = {
            "method": "addEventListener",
            "value": "pause"
          };
          helpersDZSVG.vimeo_do_command(selfClass, vimeo_data, selfClass.vimeo_url);

          vimeo_data = {
            "method": "addEventListener",
            "value": "playProgress"
          };
          helpersDZSVG.vimeo_do_command(selfClass, vimeo_data, selfClass.vimeo_url);

          //if(video){
          //
          //    selfClass._videoElement.addEvent('pause', function(){
          //        console.info('paUSE!!!');
          //    });
          //}


          cthis.addClass('dzsvp-loaded');
          if (o.gallery_object != null) {
            if (typeof (o.gallery_object.get(0)) != 'undefined') {
              o.gallery_object.get(0).api_video_ready();
            }
          }


        }

        if (data.event == 'playProgress') {
          selfClass.initial_played = true;
          if (selfClass.paused == true) {
            playMovie_visual();
          }

        }
        if (data.event == 'finish' || data.event == 'ended') {
          handleVideoEnd();
        }
      }
    }


    function handleClickPlayPause(e) {

      var _t = $(this);

      if (this && e) {
        // console.info('handleClickPlayPause() e - ',e)

        if ($(e.currentTarget).hasClass('playcontrols')) {
          if (_t.parent().parent().parent().hasClass('vplayer') || _t.parent().parent().parent().parent().hasClass('vplayer')) {

            // -- check for HD / ad reasons
          } else {
            return false;
          }
        }
      }
      if (busy_playpause_mistake) {
        return false;
      }


      busy_playpause_mistake = true;

      if (inter_clear_playpause_mistake) {
        clearTimeout(inter_clear_playpause_mistake);
      }
      inter_clear_playpause_mistake = setTimeout(function () {
        busy_playpause_mistake = false;
      }, 300);
      //return;

      if (selfClass.dataType == 'youtube' && selfClass._videoElement.getPlayerState && (selfClass._videoElement.getPlayerState() == 2 || selfClass._videoElement.getPlayerState() == -1)) {
        selfClass.paused = true;
      }

      if (e) {
        player_user_had_first_interaction();
      }

      if (selfClass.cthis.hasClass('is-video-end-screen')) {
        seek_to_perc(0);
        setTimeout(() => {
          playMovie({
            'called_from': 'handleClickPlayPause'
          });
        }, 100);
        return false;
      }

      // console.info('playpause, selfClass.paused - ', selfClass.paused);
      if (selfClass.paused) {
        playMovie({
          'called_from': 'handleClickPlayPause'
        });
      } else {
        pauseMovie({
          'called_from': 'handleClickPlayPause'
        });
      }


    }


    function handleFullscreenEnd(event) {

      console.log('handleFullscreenEnd')
      // fullscreenToggle(null, {
      //   'called_from': 'handleFullscreenEnd()',
      //   force_exit_fullscreen: true
      // })
    }


    function handleFullscreenChange(e) {
      // console.log('%chandleFullscreenChange() ', ConstantsDzsvg.DEBUG_STYLING, e);
      // console.log('document.fullscreenElement - ', document.fullscreenElement);

      is_fullscreen = !!(helpersDZSVG.fullscreen_status() == 1);

      // console.log('%c handleFullscreenChange() ', ConstantsDzsvg.DEBUG_STYLING, e, ' cthis - ', cthis, 'this - ', this);

      if (is_fullscreen) {
        // -- we have something fullscreen
        selfClass.cthis.addClass('is_fullscreen');
        if (selfClass.dataType == 'vimeo') {
          selfClass._vpInner.get(0).addEventListener('click', () => {
          }, false)
        }
      }


      if (o.touch_play_inline == 'on') {

        if (helpersDZSVG.is_ios()) {
          pauseMovie({
            'called_from': '_touch_play_inline_ios()'
          });
        }
      }

      if (!is_fullscreen) {
        fullscreen_off_commands();
      }
    }


    function fullscreenToggle(event, pargs) {
      // -- is_fullscreenscreen trigger event


      var margs = {
        'called_from': 'event',
        force_exit_fullscreen: false
      };

      if (pargs) {
        margs = $.extend(margs, pargs);
      }


      console.info('[videoplayer] fullscreenToggle()', event, margs, 'cthis - ', cthis);


      var _currElement = cthis.parent().get(0);


      // console.info(e);

      if (cthis.hasClass('is-ad')) {
        if (event && event.currentTarget) {
          if (event.currentTarget.className.indexOf('video-overlay') > -1) {
            return false;
          }
        }
      }

      //selfClass.totalWidth= $(window).width()
      //selfClass.totalHeight= $(window).height()

      selfClass.videoWidth = cthis.outerWidth();
      selfClass.videoHeight = cthis.outerHeight();


      if (helpersDZSVG.is_ios() && o.touch_play_inline == 'off') {
        playMovie({
          'called_from': 'fullscreenToggle ios'
        });
        return false;
      }

      // -- we force fullscreen status to 1 if we are forcing a exit
      var fullscreenStatus = margs.force_exit_fullscreen ? 1 : helpersDZSVG.fullscreen_status();


      // -- this was forced fullscreen so we exit it..
      if (fullscreenStatus === 0 && cthis.hasClass('is_fullscreen')) {
        fullscreen_off_commands();
        is_fullscreen = 0;
        return false;
      }

      if (fullscreenStatus === 0) {
        // (helpersDZSVG.is_ios() && o.settings_ios_usecustomskin=='on') == false
        is_fullscreen = 1;
        // console.log('fullscreenStatus -' , fullscreenStatus);

        cthis.addClass('is_fullscreen is-fullscreen');


        if (is360 && helpersDZSVG.is_ios()) {


          setTimeout(function () {

            handleResize(null, {
              'called_from': 'fullscreen 360'
            });
          }, 300)

        } else {

          if (helpersDZSVG.is_ios() && selfClass._videoElement.webkitEnterFullscreen) {
            // console.info('hmm ios fullscreen')
            selfClass._videoElement.webkitEnterFullscreen();
            return false;
          }

          // console.info('elem requestFullScreen - ', elem, elem.requestFullScreen, elem.msRequestFullscreen, elem.webkitRequestFullScreen);


          if (helpersDZSVG.requestFullscreen(_currElement) === null) {

            if (o.gallery_object) {
              o.gallery_object.find('.the-logo').hide();
              o.gallery_object.find('.gallery-buttons').hide();
            }
          }

          //jQuery('body').css('overflow', 'hidden');
          selfClass.totalWidth = window.screen.width;
          selfClass.totalHeight = window.screen.height;
          //console.log(selfClass.totalWidth, selfClass.totalHeight);

          resizePlayer(selfClass.totalWidth, selfClass.totalHeight);


          if (o.design_skin == 'skin_reborn') {
            cthis.find('.full-tooltip').eq(0).html('EXIT FULLSCREEN');
          }


          fullscreen_just_pressed = true;

          setTimeout(function () {
            fullscreen_just_pressed = false
          }, 700)

          console.info(o.settings_disable_mouse_out, o.settings_disable_mouse_out_for_fullscreen, o.settings_mouse_out_delay_for_fullscreen, cthis)
          if (o.settings_disable_mouse_out != 'on' && o.settings_disable_mouse_out_for_fullscreen != 'on') {

            clearTimeout(inter_removeFsControls);
            inter_removeFsControls = setTimeout(controls_mouse_is_out, o.settings_mouse_out_delay_for_fullscreen);
          }

        }


      } else {


        is_fullscreen = 0;
        fullscreen_off_commands();
        fullscreen_cancel_on_document();
      }


    }

    function fullscreen_off_commands() {

      cthis.addClass('remove_fullscreen');
      cthis.removeClass('is_fullscreen is-fullscreen');
      cthis.find('.vplayer.is_fullscreen').removeClass('is_fullscreen is-fullscreen');
      cthis.removeClass('is-fullscreen');

      if (o.design_skin == 'skin_reborn') {
        cthis.find('.full-tooltip').eq(0).html('FULLSCREEN');
      }


      //console.info(cthis, selfClass.videoWidth,selfClass.videoHeight);

      handleResize();
      setTimeout(handleResize, 800);
    }

    function fullscreen_cancel_on_document() {

      var elem = document;

      if (helpersDZSVG.fullscreen_status() == 1) {

        if (elem.cancelFullScreen) {
          elem.cancelFullScreen();
        } else if (elem.exitFullscreen) {
          try {
            elem.exitFullscreen();
          } catch (err) {
            console.info('error at exit fullscreen ', err);
          }
        } else if (elem.mozCancelFullScreen) {
          elem.mozCancelFullScreen();
        } else if (elem.webkitCancelFullScreen) {
          elem.webkitCancelFullScreen();
        } else if (elem.msExitFullscreen) {
          elem.msExitFullscreen();
        }
      }
    }

    function resizePlayer(warg, harg) {
      //console.log(cthis);


      calculateDims(warg, harg);

      //console.log(warg);

//                console.log(_scrubBg, warg, o.design_scrubbarWidth, (warg + o.design_scrubbarWidth));

      if (the_player_id == 'debug-video') {

        //console.info(cthis, the_player_id, warg, o.design_scrubbarWidth);
      }

      //console.info(cthis, warg, o.design_scrubbarWidth);

      if (_scrubBg) {

        _scrubBg.css({
          'width': (warg + o.design_scrubbarWidth)
        });

        if (o.design_skin == 'skin_aurora' || o.design_skin == 'skin_avanti' || o.design_skin == 'skin_default' || o.design_skin == 'skin_white') {
          _scrubBg.css({
            'width': '100%'
          });
        }

        scrubbg_width = _scrubBg.width();

      }
      if (is360) {

        Dzsvg360.resizePlayer(warg, harg);
      }


      if (selfClass._controlsDiv) {

        infoPosX = parseInt(selfClass._controlsDiv.find('.infoText').css('left'));
        infoPosY = parseInt(selfClass._controlsDiv.find('.infoText').css('top'));
      }
    }


    function calculateDims(warg, harg) {

      // console.info('vplayer calculateDims()', warg, harg, o.design_skin);
      if (o.design_skin != 'skin_bigplay') {
        /*
                     selfClass._controlsDiv.find('.background').css({
                     'width': warg + parseInt(o.design_background_offsetw)
                     })
                     */
      }


      if (selfClass.dataType == 'selfHosted') {

        if (selfClass._videoElement) {
          if (selfClass._videoElement.videoWidth) {

            natural_videow = selfClass._videoElement.videoWidth;
          }
          if (selfClass._videoElement.videoHeight) {

            natural_videoh = selfClass._videoElement.videoHeight;
          }
        } else {
          console.info('video not found ? problem');
        }

      }
      if (cthis.hasClass('pattern-video')) {
        if (selfClass.dataType == 'selfHosted') {

          if (natural_videow) {

            var nr_w = Math.ceil(selfClass.totalWidth / natural_videow);
            var nr_h = Math.ceil(selfClass.videoHeight / natural_videoh);


            for (var i = 0; i < nr_w; i++) {
              for (var j = 0; j < nr_h; j++) {


                if ((i == 0 && j == 0) || (cthis.find('video[data-dzsvgindex="' + i + '' + j + '"]').length)) {
                  continue;
                }
                $(selfClass._videoElement).after($(selfClass._videoElement).clone());
                $(selfClass._videoElement).next().attr('data-dzsvgindex', String(i) + String(j));
                $(selfClass._videoElement).next().get(0).play();
                $(selfClass._videoElement).next().css({
                  'left': (i * natural_videow)
                  , 'top': (j * natural_videoh)
                })

              }
            }


            if (nr_w) {
              for (var i = 0; i < nr_w; i++) {

              }
            }

          }
        }
      }

      /*
                 selfClass._controlsDiv.css({
                 'width': warg
                 });
                 */
    }


    function playMovie(pargs) {
      // console.info('playMovie() - ',pargs, cthis, selfClass.dataType, 'paused - ',paused);
      //console.info(selfClass.dataType);


      var margs = {
        'called_from': 'default'
      };

      if (pargs) {
        margs = $.extend(margs, pargs);
      }

      // console.info('playMovie() .. ',margs);


      if (helpersDZSVG.is_mobile()) {
        var d = new Date();
        // console.info(Number(d)-window.dzsvg_time_started);

        if (selfClass.isHadFirstInteraction === false && o.autoplayWithVideoMuted === 'off' && margs.called_from.indexOf('autoplayNext') > -1 && (Number(d) - window.dzsvg_time_started < 1500)) {
          // -- no user action
          return false;
        }
      }
      play_commited = true;
      if (cthis.hasClass('dzsvp-loaded') == false && selfClass.dataType != 'vimeo') {
        setTimeout(function () {
          // -- check if play still commited

          // console.info('check if play still commited - ',play_commited, cthis);
          if (play_commited) {

            margs.called_from = margs.called_from + ' recommit';
            playMovie(margs);
          }
        }, 500);
        return false;
      }

      if (margs.called_from == 'play_only_on_desktop') {
        if (helpersDZSVG.is_mobile()) {
          return false;
        }
      }


      cthis.find('.cover-image').fadeOut('fast');


      // console.warn('playMovie()', cthis, selfClass.dataType,paused, selfClass.initial_played, margs);

      if (o.settings_disableVideoArray != 'on') {
        for (var i = 0; i < dzsvp_players_arr.length; i++) {
//                        console.info(dzsvp_players_arr);
          if (dzsvp_players_arr[i].get(0) && dzsvp_players_arr[i].get(0) != cthis.get(0) && dzsvp_players_arr[i].get(0).externalPauseMovie != undefined) {
            dzsvp_players_arr[i].get(0).externalPauseMovie({
              'called_from': 'external_pauseMovie()'
            });
          }
        }
      }


      //return;


      if (o.try_to_pause_zoomsounds_players == 'on') {
        //console.info(dzsap_list);
        helpersDZSVG.pauseDzsapPlayers();
      }


      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'vimeo' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
        try {
          videoElementFunctions.video_play(selfClass);
        } catch (err) {
          console.info('vg - ', err);
        }

      }
      if (selfClass.dataType == 'youtube') {
        if (selfClass.paused == false) {
          return false;
        }
        videoElementFunctions.video_play(selfClass);
      }


      selfClass.wasPlaying = true;
      selfClass.paused = false;
      selfClass.initial_played = true;
      //console.log(selfClass.wasPlaying);

      // console.log('[dzsvp] playMovie() selfClass.isHadFirstInteraction ---', selfClass.isHadFirstInteraction);
      if (!selfClass.isHadFirstInteraction) {
        selfClass.is_muted_for_autoplay = true;
      }

      cthis.trigger('videoPlay');


      playMovie_visual();
      check_one_sec_for_adsOrTags();


      //console.info(o.action_video_view);
      if (action_video_view) {
        if (view_sent == false) {
          action_video_view(cthis, video_title);
          view_sent = true;
        }
      }


    }

    function playMovie_visual() {

      //console.warn("playMovie_visual()");


      // playcontrols.children().eq(0).fadeOut('fast');
      // playcontrols.children().eq(2).fadeIn('fast');
      //
      // if(cthis.hasClass('skin_aurora')==false && cthis.hasClass('skin_bigplay')==false && cthis.hasClass('skin_pro')==false){
      //
      //     playcontrols.children().eq(1).fadeOut('fast');
      //     playcontrols.children().eq(3).fadeIn('fast');
      // }


      cthis.addClass('first-played');

      if (selfClass.isAd) {

        o.parent_player.removeClass('pretime-ad-setuped');


        // console.info('ad, gallery_object - ', o.gallery_object);

        if (o.parent_player.get(0) && o.parent_player.get(0).gallery_object) {
          $(o.parent_player.get(0).gallery_object).removeClass('pretime-ad-setuped')
        }

      }


      if (o.settings_disableControls != 'on') {
      }

      if (o.google_analytics_send_play_event == 'on' && window._gaq && google_analytics_sent_play_event == false) {
        //if(window.console){ console.info( 'sent event'); }
        window._gaq.push(['_trackEvent', 'Video Gallery Play', 'Play', 'video gallery play - ' + selfClass.dataSrc]);
        google_analytics_sent_play_event = true;
      }


      if (o.settings_disable_mouse_out != 'on') {


        if (helpersDZSVG.is_mobile()) {
          clearTimeout(inter_removeFsControls);
          inter_removeFsControls = setTimeout(controls_mouse_is_out, o.settings_mouse_out_delay_for_fullscreen);
        }

      }


      cthis.addClass('is-playing');
      cthis.removeClass('is-video-end-screen');
      if (o.gallery_object && o.gallery_object.get(0) && o.gallery_object.get(0).api_played_video) {
        o.gallery_object.get(0).api_played_video();
      }

      selfClass.paused = false;
      selfClass.wasPlaying = true;
      selfClass.initial_played = true;


      if (action_video_play) {
        action_video_play(cthis, video_title);
      }
    }

    function pauseMovie_visual() {

      //
      // if(cthis.hasClass('skin_aurora')==false && cthis.hasClass('skin_bigplay')==false && cthis.hasClass('skin_pro')==false){
      //
      //     playcontrols.children().eq(1).fadeIn('fast');
      //     playcontrols.children().eq(3).fadeOut('fast');
      // }
      //
      // playcontrols.children().eq(2).fadeOut('fast');
      // playcontrols.children().eq(0).fadeIn('fast');


      selfClass.wasPlaying = false;
      selfClass.paused = true;


      cthis.removeClass('is-playing');

      if (action_video_pause) {
        action_video_pause(cthis, video_title);
      }

    }

    function pauseMovie(pargs) {

      //console.info(selfClass.dataType, selfClass.paused);
      //if(selfClass.dataType!='vimeo' && selfClass.paused==true){
      //    return;
      //}

      //console.info('selfClass.initial_played', selfClass.initial_played);

      var margs = {
        'called_from': 'default'
      };

      if (pargs) {
        margs = $.extend(margs, pargs);
      }


      play_commited = false;
      if (o.try_to_pause_zoomsounds_players == 'on') {
        if (window.dzsap_player_interrupted_by_dzsvg) {

          window.dzsap_player_interrupted_by_dzsvg.api_play_media({
            'audioapi_setlasttime': false
          });
          window.dzsap_player_interrupted_by_dzsvg = null;
        }
      }

      // console.warn('pauseMovie() - ', cthis, selfClass.dataType,paused, selfClass.initial_played, margs);

      if (selfClass.initial_played == false) {
        return false;
      }
      selfClass.suspendStateForLoop = true;
      setTimeout(function () {
        selfClass.suspendStateForLoop = false;
      }, 1500);

      //console.info(selfClass.initial_played);

      pauseMovie_visual();

      if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
        if (selfClass._videoElement != undefined) {
          selfClass._videoElement.pause();
        } else {
          if (window.console != undefined) {
            console.info('warning: video undefined')
          }
          ;
        }
      }
      if (selfClass.dataType == 'youtube') {
        //return false;

        //console.info('pause YOUTUBE',video ,selfClass._videoElement.pauseVideo);

        if (selfClass._videoElement && selfClass._videoElement.pauseVideo) {

          try {
            selfClass._videoElement.pauseVideo();
          } catch (err) {
            if (window.console) {
              console.log(err);
            }
          }
//                        console.info('pauseMovie',video, selfClass._videoElement.pauseVideo, paused);
        }
      }

      if (selfClass.dataType == 'vimeo') {
        //if (/Opera/.test(navigator.userAgent)) {
        //    return;
        //}
        vimeo_data = {
          "method": "pause"
        };

        if (selfClass.vimeo_url) {
          try {
            selfClass._videoElement.contentWindow.postMessage(JSON.stringify(vimeo_data), selfClass.vimeo_url);

            //console.info(vimeo_data, selfClass.vimeo_url);
            selfClass.wasPlaying = false;
            selfClass.paused = true;
          } catch (err) {
            if (window.console) {
              console.log(err);
            }
          }
        }
        return;
      }


      selfClass.wasPlaying = false;
      selfClass.paused = true;

      mouse_is_over();

      cthis.removeClass('is-playing');
    }

    function reinit_cover_image() {

      cthis.find('.cover-image').fadeIn('fast');
    }

    //console.log(cthis);
    try {
      cthis.get(0).checkYoutubeState = function () {
        if (selfClass.dataType == 'youtube' && selfClass._videoElement.getPlayerState != undefined) {
          //console.log("ceva", cthis, selfClass._videoElement.getPlayerState());
          if (selfClass._videoElement.getPlayerState && selfClass._videoElement.getPlayerState() == 0) {
            handleVideoEnd();
          }
        }
      }

    } catch (err) {
      if (window.console)
        console.log(err);
    }
    /*
             window.checkYoutubeState=function(){
             // - we check if video youtube has ended so we can go to the next one

             }
             */

  }
}


window.setup_videogalleryCategories = helpersDZSVG.setup_videogalleryCategories;


//-------VIDEO PLAYER
(function ($) {
  $.fn.vPlayer = function (argOptions) {

    var finalOptions = {};
    var defaultOptions = Object.assign({}, require('./configs/_playerSettings').default_opts);
    finalOptions = helpersDZSVG.convertPluginOptionsToFinalOptions(this, defaultOptions, argOptions);
    this.each(function () {

      var _vg = new DzsVideoPlayer(this, finalOptions, $);
      return this;
    }); // end each

  }


  window.dzsvp_init = function (selector, settings) {
    //console.info($(selector), settings);


    if (typeof (settings) != "undefined" && typeof (settings.init_each) != "undefined" && settings.init_each == true) {
      var element_count = 0;
      for (var e in settings) {
        element_count++;
      }
      if (element_count == 1) {
        settings = undefined;
      }

      $(selector).each(function () {
        var _t = $(this);
        // console.log('vplayer settings -8 ', settings);
        _t.vPlayer(settings)
      });
    } else {
      $(selector).vPlayer(settings);
    }


  };


  if (!window.dzsvg_settings) {
    if (window.dzsvg_default_settings) {
      window.dzsvg_settings = window.dzsvg_default_settings;
    }
  }

  require('./js_dzsvg/_dzsvg_galleryplugin').apply_videogallery_plugin(jQuery);


})(jQuery);


jQuery(document).ready(function ($) {
//    --- mega conflict with mediaelement.js, well workaround by treating untreated flash items

  var inter_check_treat = 0;

  clearTimeout(inter_check_treat);
  inter_check_treat = setTimeout(workaround_treatuntretreadItems, 2000);

  function workaround_treatuntretreadItems() {
    jQuery('.js-api-player:not(.treated)').each(function () {
      var _t = jQuery(this);
      var $ytApiPlayer_ = _t.get(0);
//            console.info(_t, __t);

      var playerId = _t.attr('id');

      var aux = playerId.substr(8);
      var aux2 = _t.attr('data-suggestedquality');
      //console.log(aux2);

      if (typeof $ytApiPlayer_.loadVideoById != 'undefined') {
        $ytApiPlayer_.loadVideoById(aux, 0, aux2);
        $ytApiPlayer_.pauseVideo();
      } else {

        inter_check_treat = setTimeout(workaround_treatuntretreadItems, 2000);
      }


    })

  }

  // -- we save the other youtube player ready functions ( maybe conflict with other players )
  if (window.onYouTubePlayerReady && typeof window.onYouTubePlayerReady == 'function' && typeof backup_onYouTubePlayerReady == 'undefined') {
    window.dzsvg_backup_onYouTubePlayerReady = window.onYouTubePlayerReady;
  }


  helpersDZSVG.init_navigationOuter();
  _secondCon.init_secondCon();
});


jQuery(document).ready(function ($) {
  //console.info($('.zoomvideogallery.auto-init'));
  dzsvp_init('.vplayer-tobe.auto-init', {init_each: true});
  dzsvg_init('.videogallery.auto-init', {init_each: true});


  helpersDZSVG.registerAuxjQueryExtends($);

  _secondCon.secondCon_initFunctions();

  var d = new Date();
  window.dzsvg_time_started = d.getTime();


});


helpersDZSVG.dzsvgExtraWindowFunctions();

window.dzsvg_curr_embed_code = '';

